export const EN = {
  preparing_zip: "Preparing zip…",
  compressing: "Compressing…",
  info_icon: "Once marked as completed, no additional members can join or be added, and all chat groups will be deactivated. Please note that the project, along with all chat groups and data, will remain accessible in a deactivated state.",
  mark_is_done: "Are you sure you want to mark the project as completed? Once marked, no additional members can join or be added, and all chat groups will be deactivated. Please note that the project, along with all chat groups and data, will remain accessible in a deactivated state.",
  mark_not_done: "Are you sure you want to re-open the project? Once marked as open, additional members can join or be added, and all chat groups will be reactivated.",
  mark_as_completed: "Mark project as completed",
  room_completed: "Project completed",
  room_members: "Project members",
  deactivated_rooms: "Deactivated projects",
  deactivated_chats: "Deactivated chats",
  completed_rooms: "Completed projects",
  request_to_join_a_room: 'Request to join the project',
  wants_to_rejoin_room: 'Username wants to rejoin the project Roomname.',
  invited_you_to_join_room: 'Username invited you to join the project Roomname.',
  restart: "Restart",
  update_text: "A new update is available. Click on restart to install the update.",
  update_availble: "Update available",
  Loading: "Loading...",
  logout: "Logout",
  back: 'Back',
  company_list: "Company List",
  followers: "Followers",
  followings: "Followings",
  article: "Article",
  companies: "Companies",
  one_to_one_chat: " One to One chat",
  profile: "Profile Settings",
  company: "Company",
  company_selection: "Company selection",
  home: "Home",
  contact: "Contact ",
  add_company: "Add Company ",
  add_project: "Add Project ",
  capacities: "Capacities ",
  work_area: "Work Area",
  company_services: "Company services",
  website: "Website",
  website_optional: "Website (optional)",
  optional: "optional",
  search_contacts: "Search contacts",
  add_or_join_a_company: "Add or join a company",
  follow: "Follow",
  following: "Following",
  like: "Like",
  company_contacts: "Company contact",
  leave_the_company: "Leave the company",
  news: "News",
  earlier: "Earlier",
  action: "Action",
  another_action: "Another action",
  something_else: "Something else",
  search: "Search",
  search_rooms: "Search projects",
  search_articles: "Search articles",
  contacts: "Contacts",
  suggestions: "Suggestions",
  project_list: "Project list",
  search_results: "Search results",
  add_or_join_project: "Add or join project",
  details: "Details",
  your_position_within_company:
    "Please choose your position within the company.",
  close_modal: "Close",
  map: "Map",
  or: "Or",
  name: "Name*",
  street: "Street*",
  house_number: "House No.",
  postal_code: "Postal Code",
  city: "City*",
  opened_by: "Opened by:",
  project_No: "Project-no: ",
  building_type: "Building Type*",
  building_types: "Building Type",
  add_join: "Add/Join",
  mandatory_fiels: "*mandatory fields",
  invalid_fiels: "This field is required",
  add_or_join_company: "Add or join company",
  name_of_the_company: "Name of the company",
  edit_company_details: "Edit company details",
  branch_of_the_building_industry: "Branch of the building industry",
  corporate_form: "Corporate form",
  position_within_company: "Position within the company",
  request_confirmation: "Pending project requests",
  company_e_mail: "Company e-mail",
  type_of_filter: "Type to filter...",
  setting: "Setting",
  dashboard: "Dashboard",
  settings: "Settings",
  views: "Views",
  times_seen: "time seen",
  see_more: "...more",
  see_less: "...less",
  in_search: "in search",
  reset_password: "Reset Password",
  submit: "Submit",
  password: "Password",
  email: "Email",
  confirm_password: "Confirm Password",
  reset_email: "Reset E-Mail",
  update: "Update",
  new_email: "New E-Mail",
  kjuup_message: "Kjuup Message",
  delete_profile: "Delete Profile?",
  my_position: "My Position:",
  add: "add",
  owner_company_admin: "Company admin :",
  owner_company_admin_new: "Company admin",
  mutual_contact: "mutual contact",
  mutual_contacts: "mutual contacts",
  co_owner: "Co-owner",
  managing_director: "Managing Director",
  associate: "Associate",
  secretary: "Secretary",
  employee: "Employee",
  project_manage: "Project Manager",
  auto_chat_translation: "Auto Chat Translation",
  auto_translation_languages_title: "Automatic translation languages",
  auto_translation_languages_info: "Select which message languages should be automatically translated into your interface language. Deselect a language to keep messages written in that language in the original wording.",
  auto_translation_languages_save: "Save translation languages",
  auto_translation_languages_saved: "Translation language settings saved",
  auto_translation_languages_your_language: "your language",
  translate_room_group_names: "Translate chat group names",
  translate_room_group_names_info: "When enabled, chat group names are automatically translated into your interface language.",
  email_summary_preview: "Email summary as preview",
  email_summary_preview_info: "When enabled, the message list shows a one-sentence summary of each email. When disabled, the first sentence of the email is shown.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "When enabled, the E-Mail tab will open by default instead of Messages when you open the app.",
  integrate_email_in_messages: "Combine Email & Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Language",
  english: "English",
  german: "German",
  french: "French",
  italian: "Italian",
  change_language: "Change Language",
  my_companies: "My Companies",
  employees: "Employees",
  invite_with_a: "Invite to Kjuup",
  add_member: "Add Member",
  room_action_members: "Members",
  room_action_add: "Add",
  room_action_media: "Files",
  room_tab_overview: "Overview",
  room_tab_history: "History",
  room_overview_status_title: "Current status",
  room_overview_as_of: "As of {{time}}",
  room_overview_empty: "No status for this project yet",
  room_overview_empty_hint: "The status is written every night for projects with new messages, emails or tasks.",
  room_overview_priorities_title: "Current status and priorities",
  room_overview_no_priorities: "No open priorities in the latest report.",
  room_overview_priority_no_detail: "The report gives no further details on this priority.",
  room_overview_priority_from: "Source: {{name}}",
  room_overview_priority_open_task: "Open task",
  cockpit_priority_position: "{{index}} of {{total}} priorities",
  room_overview_today_title: "Important today",
  room_overview_all_tasks: "All",
  room_overview_tasks_empty: "No open deadlines or tasks",
  room_overview_appointments_empty: "No upcoming appointments",
  pro_todo_room_empty_today: "No tasks for today in this project",
  pro_todo_room_empty_day: "No tasks on this day in this project",
  create_chat: "Create chat",
  create_email: "Create email",
  add_user: "Add User",
  send_location: "Send Location",
  assign_admin_rights: "Adjust admin right",
  deactivate_company: "Deactivate Company",
  remove_employees: "Remove Employees",
  remove_members: "Remove members",
  no_user_found: "No user found!",
  approve: "Approve!",
  deselect_all: "Deselect All",
  select_all: "Select All",
  translation_on_building_projects: "Translation in projects",
  reported_capacities: "Reported services",
  up_to_50m_exact: "Up To 50m Exact",
  company_details_service: "Company Services",
  company_contact: "Company Contact",
  invite_with_link: "Invite to Kjuup",
  share_link: "Share Link",
  share_company_link: "Share link",
  qr_code: "Qr Code",
  copy_link: "Copy Link",
  cancel_link: "Cancel Link",
  who_has_confirmed_services: "Who has confirmed your services?",
  projectss: "Projects",
  add_services: "Add Services",
  services: "Services",
  save_text: "Save",
  share_on: "Share On:",
  articlen: "Article",
  invite_user_to_confirm_service:
    "Invite users to confirm services to the company.",
  link_copied: "Link Copied!",
  email_copied: "Email Copied!",
  personal_article: "Personal Article",
  company_article: "Company Article",
  characters_remaining: "Characters Remaining",
  optional_information: "Optional Information",
  project: "Project",
  projects: "Projects...",
  abort: "Discard",
  preview: "Preview",
  post: "Post",
  of: "of",
  remove: "Remove",
  free_capacity: "Job portal",
  current_status_overview: "Current Status Overview",
  report_capacities: "Report services",
  report_text: "Report",
  search_capacities: "Find contractors",
  add_project_user: "Add Project User",
  media: "Media",
  links: "Links",
  docs: "Docs",
  media_filter_photos: "Photos",
  media_filter_docs: "Documents",
  media_filter_source: "Source",
  featured_products: "Featured Products...",
  title: "Title",
  text: "Text",
  feed_details: "Feed Details",
  add_employee: "Add Employee",
  latest: "Latest",
  my_projects: "My Projects",
  cancel: "Cancel",
  continue: "Continue",
  role_in_the_building_industry: "Role in the Building Industry",
  als: "as",
  join: "join",
  find: "Find",
  request_to_join_a_company: "Request to join the company",
  wants_to_join_the_company: "wants to join the company",
  filter_by: "Filter by",
  ok: "Ok",
  close: "Close",
  weekly_statistics: "Weekly Statistics",
  is_following_you: "is following you.",
  as: "as",
  has_joined_the: "has joined the company",
  has_looked_at_your_profile: "has looked at your profile.",
  time: "time",
  in_searches_in_past_week: "in searches in past week.",
  has_liked_your_article: "has liked your article.",
  has_published_a_new_article: "has published a new article.",
  you: "You",
  all_views: "All Views",
  all_profile_views: "All Profile Views",
  mutual_company: "mutual company",
  artical_text: "Write article...",
  you_have_appeared: "You have appeared",
  your_request_at_the_company: "Your request at the company",
  times_you_have_appeared_in_searches: "times you have appeared in searches",
  appear_more_often_in_searches: "Appear more often in searches",
  you_have_been_found: "You have been found",
  improve_profile: "Improve Profile",
  choose_existing_contact_for_single_chat:
    "Choose existing contact for single chat:",
  in_order_to_add_new_contacts:
    "In order to add new contacts please search for new contacts on the profile page.",
  times_in_searches_in_the_last_week:
    "times in searches in the last week. Update your profile and add further detail in order to be found more easily.",
  has_been_confirmed: "has been confirmed.",
  have_joined_the: "have joined the  ",
  building_project: " building project.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Select the company you'll be representing. This will be displayed to other participants.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Select the company you'll be representing. This will be displayed to other participants.",
  select_internal_section: "Please select internal section",
  select_profile_image: "Select Profile Image",
  share_user: "Share User",
  contact_sender_message:
    "Share this link to invite a non-member of Kjuup to Kjuup. This link can be used by multiple people to register.",
  project_sender_message:
    "Share this link to invite a non-member of Kjuup to the project project name. This link can be used by multiple people to register and join the project project name in Kjuup.",
  company_sender_message:
    "Share this link to invite a non-member of Kjuup to the company company name. This link can be used by multiple people to register and join the company in Kjuup.",
  contact_receivers_message:
    "Invitation link to join Kjuup. Please click the link to register for kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "In case you are installing Kjuup via Apple App Store, you must click this link after successful download, to be able to register.",
  project_receivers_message:
    "Invitation link to join the project project name in Kjuup. Please click the link to register for Kjuup and to join the project project name.",
  company_receivers_message:
    "Invitation link to the company company name in Kjuup. Please click on the link to register for Kjuup and to join the company company name.",
  sign_in: "Sign in",
  enter_your_email_add: "Enter your email address",
  forgot_password: "Forgot Password",
  dont_have_account: "Don't have an account ?",
  register: "Register",
  get_app: "Get the app",
  registration: "Registration",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "Prof.",
  first_name: "First name",
  last_name: "Last name",
  have_an_account: "Have an account ?",
  when_register_you_agree: "When registering you agree to our",
  term_of_use: "term of use",
  to: "to.",
  in_our: "In our",
  data_policy: "data policies",
  they_find_out: "they find out,",
  we_provide_store_data: "how we collect, process and store information.",
  leaving_company_text:
    "Do you really want to leave the company? When leaving the company you also leave all associated projects and chat groups. You can re-join these projects with another company any time.",
  delete_profile_text:
    "Do you really want to delete your profile? When you delete your profile all connections to companies, projects and chats will be removed. You can create a new profile any time.",
  confirm: "Confirm",
  reject: "Reject",
  requet_to_leave: "Request to leave",
  choose: "Choose",
  your_add_member: "Add member",
  if_you: "in case you",
  can_not_find: "cannot find your contact here.",
  please_wait: "Please wait..",
  imprint_gtc: "Imprint/GTC",
  register_confirm_title: "Confirm your email before you log in",
  register_confirm_popup:
    "Please verify your Kjuup email address before you log in. A login is only possible after you have confirmed this email. We have sent a confirmation link to your inbox. If you do not see it, please check your spam folder.",
  resend_confirmation_email: "Resend confirmation email",
  resend_confirmation_sent: "If this email is waiting for confirmation, we have sent a new link.",
  PENDING_GROUP_USER:
    "will receive messages only after invitation to the project has been confirmed. An additional message will appear once the invitation to the project has been confirmed.",
  PENDING: "Confirmation of invitation to the project pending",
  denied_group_chat: " has denied the project invitation and has left this group.",
  // joined_group_chat: " has joined the room and this group.",
  joined_group_chat: " joined this group",
  you_joined_group_chat: "You joined this group.",
  Others: "Others",
  LEFT_GROUP: "has left this chat group.",
  YOU_LEFT_GROUP: "have left this chat group.",
  days: "days",
  day: "day",
  hour: "hour",
  hide_project: "Hide project",
  hide_project_popup_text:
    "If you hide projects, they cannot be found within Kjuup. Only members of the project can invite new users to the project.",
  branch: "Branch",
  photo_video_media_lib: "Photo - Video media library",
  video_too_large: "Videos must be 200 MB or smaller.",
  video_too_long: "Videos must be 15 minutes or shorter.",
  video_invalid: "This video could not be read.",
  video_one_at_a_time: "Please select one video at a time.",
  video_or_images_only: "Please select either images or a single video.",
  video_processing: "Compressing video…",
  video_uploading: "Uploading video…",
  article_publish_preparing: "Preparing…",
  article_publish_compressing_video: "Compressing video…",
  article_publish_preparing_media: "Preparing photos…",
  article_publish_uploading: "Uploading media…",
  article_publish_finishing: "Publishing…",
  document: "Document",
  location: "Location",
  location_meeting: "Location / Meeting",
  all_member_of_project: "All members of the project",
  pending_request: "Pending project requests",
  no_pending_request: "No pending requests found!",
  news_feed: "News-Feed",
  user_info: "Group Info",
  leave_project: "Leave project",
  media_link_docs: "Files",
  search_chat: "Search Chat",
  export_chat_group: "Export chat group data",
  export_chat_timeframe: "Timeframe",
  export_chat_last_week: "Last week",
  export_chat_last_month: "Last month",
  export_chat_last_3_months: "Last 3 months",
  export_chat_custom: "Custom",
  export_chat_from: "From",
  export_chat_to: "To",
  export_chat_start: "Export",
  export_chat_progress_fetching: "Fetching messages...",
  export_chat_progress_generating: "Generating PDF...",
  export_chat_progress_downloading: "Downloading...",
  export_chat_progress_done: "Export complete",
  export_chat_progress_error: "Export failed",
  export_chat_no_messages: "No messages found in this timeframe",
  export_chat_invalid_range: "Please select a valid date range",
  request_complete_chat_history: "Request complete chat history",
  leave_chat_group: "Leave chat group",
  add_user_project: "Add User",
  me: "Me",
  max_open_one_to_one:
    "Currently max. 2 one-on-one chats can be opened in parallel on bottom - and top section. In total max. 4 one-on-one chats are possible.",
  are_you_sure_you_want_leave_chat:
    "Are you sure, you want to leave this chat group?",
  create_group: "Create Group",
  adding_members: "Adding Members...",
  creating_the_chat: "Creating the Chat...",
  finishing_setup: "Finishing Setup...",
  group_name: "Group Name",
  by: "Von:",
  mandetory: "*mandatory",
  delteed: "has deleted his/her profile and has left the group chat.",
  deleted_direct: "has deleted his/her profile and has left the chat.",
  unhidden_message:
    "If you unhide projects, they can be found by all members of Kjuup.",
  account_deleted: "Account has been deleted.",
  refuse_company: "Are you sure you want to refuse the company invitation?",
  follow_additional: "Follow additional users",
  f_add:
    "Follow additional users of Kjuup to make them available for direct messages.",
  c_inv: "Company invitation(s)",
  invited_o_Company: "You have been invited to join the company",
  refuse_companyX: "Are you sure you want to refuse the company request?",
  a_Da: "Account deactivated.",
  has_deactivated: "has deactivated his/her profile.",
  reactive: "has reactivated his/her profile.",
  juup_note: "*Registration with username only available for members of Kjuup+",
  username: "Username*",
  email_username: "Email/Username*",
  sPinText:
    "Please provide a 6-digit security pin. This pin will be needed in case you forget your password and is mandatory to confirm your account.",
  DeleteKjuupPlusText:
    "Do you really want to delete your profile? When you delete your profile all connections to companies, projects and chats will be removed.\n\nWithin 48h after account deletion you can reactivate your account by signing in with username, password and pin.",
  reactive_text:
    "Your account has been deleted. Please click on Reactivate to reactivate your account.",
  rac: "Reactivate",
  ac_ss: "Account reactivated successfully.",
  not_valid_pin: "Pin invalid",
  only_for_kjuup:
    "*Password reset via username and pin only available for Kjuup+ members.",
  resetPIN: "Reset PIN",
  enter_current_pin: "Please enter your current PIN",
  enter_new: "Enter new PIN",
  pin_to_confirm: "Please provide the PIN to confirm.",
  change_username: "Reset Username",
  pp_not_match: "Password - and Confirm Password don't match",
  reactive_itself: "You have reactivated your profile.",
  has_deactivated_itself: "You have deactivated your profile.",
  more_than_two:
    "Currently direct messages can be only done with 2 users in parallel.",
  Chats: "Direct Messages",
  only_in_mobileL:
    "Native videos can currently only be uploaded and posted via mobile App. Please use video links of Youtube and Vimeo.",
  register_pin_text:
    "Please choose your personal 6-digit PIN. This PIN will be needed to enable account reset functionalities.",
  internal_project: "Internal",
  external_projects: "External",
  in_deacticted: "Internal section is deactivated.",
  create_article: "Create Article",
  new_article_selection: "Create article for external News-Feed",
  new_article_selection_internal: "Create in-house article",
  active_trans_title: "Turn on automatic translation?",
  active_trans:
    "When enabled, all incoming chat messages will be translated into your selected app language.",
  disable_trans: "Do you really want to deactivate automatic translation?",
  allow_access_chat: "Show full chat history",
  toggle_chat_history_on:
    "Do you really want the user to see the full chat history?",
  toggle_chat_history_off:
    "Do you really want the user to only see the chat history from the point of joining the chat?",
  check_selected_settings:
    "Please check the settings for chat history for all selected users!",
  chat_from_start_have:
    "You have joined this group. The chat history has been shared.",
  chat_from_start_has:
    "has joined this group. The chat history has been shared.",
  Address: "Address",
  read_by: "Read by",
  deliver_to: "Delivered to",
  remaining: "remaining",
  message_info: "Message Info",
  request_to_join_only: "Request to join",
  unfollow: "Unfollow",
  company_username: "Username",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Remove my admin rights",
  makeEmp: "Do you really want to remove company admin rights from the user?",
  remove_my_self:
    "Do you really want to remove company admin rights from your account?",
  makeAdmin: "Do you really want to give the user company admin rights?",
  remove_member: "Remove Member",
  remove_following_confirm: "Do you really want to remove {name}?",
  remove_follower_confirm: "Do you really want to remove {name} from following you? If you remove him/her he/she will not get informed.",
  do_you_really_want_to_remove:
    "Do you really want to remove username from the company?",
  invite_all: "Invite all members of the company",
  invite_all_members: "Invite all members",
  mems: "All other members",
  dep_loc: "Department/Location/Team",
  notify_employees_via_dm: "Inform employees via direct message",
  notify_employees_via_dm_hint: "Sends a chat message from your account to employees of the selected departments, locations or teams when the article is published.",
  notify_employees_via_dm_hint_edit: "Sends a chat message from your account to employees of the selected departments, locations or teams about the changes.",
  depAdmin: "Department Admin",
  add_remove_admin: "Add/Remove company admin position",
  add_remove_dep_admin: "Add/Remove department admin position",
  remove_employees_dept: "Remove Employees From",
  want_to_join_dep:
    "Username wants to join the Department/Location/Team depname of the company companyname.",
  you_invited:
    "You have been invited to join the Department/Location/Team depname of the company companyname.",
  dep_remove:
    "Do you really want to remove admin rights for department or location from the user?",
  add_dep:
    "Do you really want to give the user admin rights for the department or location?",
  my_self_dep_remove:
    "Do you really want to remove department admin rights from your account?",
  member: "Member",
  admin: "Admin",
  remove_project_admin:
    "Do you really want to remove the member from the project?",
  remove_my_self_project: "Do you really want to remove admin rights?",
  remove_member_admin_right:
    "Do you really want to remove admin rights from the user?",
  add_member_admin_right: "Do you really want to add admin rights to the user?",
  add_remove_Poss: "Add/Remove admin position",
  forward: "Forward",
  forward_to: "Forward to...",
  tap_to_forward: "Tap a chat to send",
  new_conversation: "New chat",
  room_create_kjuup_chat: "Kjuup chat",
  room_create_email: "Email",
  room_create_teams_chat: "Teams chat",
  select_more_messages: "Select more messages",
  message: "message",
  messages: "messages",
  edit: "Edit",
  only_kjuup_plus_can: "Only Kjuup+ companies can post articles.",
  add_images: "Add image(s)",
  add_images_or_pdf: "Add images, videos or PDFs",
  drop_files_here: "Drop files here",
  drag_and_drop_hint_pdf: "or drag & drop images, videos or PDFs here",
  unsupported_file_type: "Unsupported file type. Only images, videos and PDFs are allowed.",
  max_file_size_exceeded_25mb: "Max. size of 25MB exceeded. Please choose a smaller file.",
  request_confirmation: 'Pending project invitations',
  Activity: "Activity",
  latest_messages: "Latest messages",
  hours: "hours",
  minute: "minutes",
  seconds: "seconds",
  days: "days",
  yesterday: "yesterday",
  last_week: "Last Week",
  this_week: "This Week",
  next_week: "next week",
  Last_month: "Last Month",
  this_month: "This Month",
  All: "All",
  register_plus: "Registration Plus",
  select_files: "Select files",
  monthsFullName: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  company_deploc_receivers_message:
    "Invitation link to the department of the company company name in Kjuup. Please click on the link to register for Kjuup and to join the company company name.",
  no_news: "No news available",
  reminder: "Reminder",
  np_reminder: "No ToDo's",
  move_to_reminder: "Move to ToDo",
  remove_reminder: "Do you really want to remove this message from the list of your ToDo's?",
  remove_all_reminder: "Remove all ToDo's",
  remove_all_confirm: "Do you really want to remove all messages from the list of your ToDo's?",
  remove_from_reminder: "Remove from Reminder",
  prevent_email: "E-Mail cannot be used as Username.",
  allow_noti: "Please allow notifications.",
  join_cap: "Join",
  pass_minimum:
    "**Password requires 12 characters incl. small -, capital letter, number and special character.",
  pass_error: "Please check password requirements",
  people_that_like_article: "People that like the article.",
  people_who_like_article: "People who like your article.",
  message_delete: "This message has been deleted.",
  message_edited: "edited",
  edit_message: "Edit message",
  edit_window_expired: "Messages can only be edited within 10 minutes of posting.",
  message_edit_save: "Save",
  copy: "Copy",
  bookmark: "Bookmark",
  add_reaction: "Add reaction",
  delete_message: "Delete message",
  more_options: "More options",
  reacted_with: "reacted with",
  show_draft: "Show Draft...",
  draft_prefix: "Draft:",
  delete_message_confirm: "Do you really want to delete this message?",
  link_invite: "Invite via link",
  ll_nkk: "Invite to Kjuup",
  selected: "Selected",
  is_active: "Active",
  inactive: "Inactive",
  last_online: "last seen {{when}}",
  remove_user_l: "Remove",
  assign_group_admin_rights: "Assign admin rights",
  remove_group_admin_rights: "Remove admin rights",
  link_expire: "Each generated Link will be valid for 72 hours.",
  company_language: "Company language",
  settings_admin_info: "Information",
  settings_admin_departments: "Departments & Employees",
  settings_admin_notifications: "Notifications",
  settings_admin_translation: "Translation languages",
  settings_admin_startup: "Startup screen",
  settings_admin_my_space: "My Space",
  settings_admin_add_employees: "Add Employees",
  settings_admin_project_partners: "Add project partners",
  settings_admin_partner_companies: "Add partner companies",
  settings_admin_rooms: "Projects / Chats",
  settings_admin_documents: "Company documents",
  settings_admin_articles: "Articles",
  settings_admin_article_translations: "Translations for internal articles",
  company_language_info:
    "The language selection will be used for all email confirmations concerning the company.",
  article_translation_target_languages_title: "Article translation languages",
  article_translation_target_languages_info:
    "Choose which Kjuup interface languages this company’s articles should be translated into. By default, the same languages as for external articles are selected. Company admins can change this list.",
  article_translation_target_languages_save: "Save",
  article_translation_languages_saved: "Article translation languages saved",
  article_original_language: "Original language",
  article_original_language_info:
    "The language the article is written in. The article will not be translated into this language.",
  s_image: "image",
  m_image: "images",
  removeMsg: "Tap to remove",
  block: 'Block',
  unblock: 'Unblock',
  blocks: 'Are you sure you want to block this user?',
  unblocks: 'Are you sure you want to unblock this user?',
  bolcked_click_un_block:
    'You have blocked this contact. Click here to remove blocking.',
  you_blocked_contact: 'You have blocked this contact.',
  you_unblocked_contact: 'You have unblocked this contact.',
  you_have_unblocked: 'You have unblocked this contact.',
  you_have_blocked: 'You have blocked this contact.',
  unblock_to_send: 'Unblock user to send message.',
  pilot_text: "Specialized AI for construction topics",
  support_text: "Chat with Kjuup Support",
  todo_notification_label: "Counter and Push-Notifications for assigned ToDo's",
  todo_notification_info: "You'll be notified whenever a new ToDo is assigned to you.",
  email_push_notification_label: "Push notifications for new emails",
  email_push_notification_info: "You'll be notified when a new email arrives in your inbox.",
  email_push_notification_io_only: "Only available with Kjuup.io – e-mail integration is part of the Kjuup.io plan.",
  daily_briefing_label: "Daily report",
  daily_briefing_info: "Creates one daily report for all projects in Messages at the time you set below, when you have an email account connected and at least one project had activity. It is not sent by email.",
  daily_briefing_notification_label: "Counter notifications for daily report",
  daily_briefing_notification_info: "Shows the number of unread daily reports on the Projects icon, the relevant project, and the Daily report tab.",
  daily_briefing_hour_label: "Daily report time",
  daily_briefing_hour_info: "The daily report is created at this time (Europe/Berlin). If today's time has already passed, it is created shortly.",
  daily_briefing_hour_saved: "Daily report time updated",
  daily_briefing_model_label: "AI model for the daily report",
  daily_briefing_model_internal: "Internal (Kjuup AI)",
  daily_briefing_model_external: "External (Mistral)",
  daily_briefing_model_internal_info: "Runs on Kjuup's own servers. Content never leaves Kjuup.",
  daily_briefing_model_external_info: "Latest suitable model from Mistral AI (France). Content from your projects is sent to Mistral to write the report.",
  daily_briefing_model_info: "Applies from the next daily report.",
  daily_briefing_model_saved: "Daily report model updated",
  room_daily_briefing_label: "Individual project daily report",
  room_daily_briefing_info: "When enabled, a daily report for this project is generated every 24 hours at the time specified in your personal settings—but only if there has been activity during that period.",
  email_style_personalization_label: "Use my writing style for email suggestions",
  email_style_personalization_info: "When enabled, reply suggestions learn from your sent emails and chats. The raw texts are not stored.",
  email_style_rebuild: "Reset writing style",
  email_style_rebuild_confirm_title: "Reset writing style?",
  email_style_rebuild_confirm: "The current learned writing style will be discarded and rebuilt from your latest sent emails and chats.",
  email_style_rebuild_confirm_ok: "Reset",
  email_style_rebuilt: "Writing style was reset.",
  email_style_rebuild_failed: "Could not reset the writing style.",
  email_suggestion_concise: "Concise",
  email_suggestion_balanced: "Balanced",
  email_suggestion_warm: "Warm",
  email_suggestion_regenerate: "Regenerate",
  email_suggestion_shorter: "Shorter",
  email_suggestion_more_formal: "More formal",
  email_suggestion_friendlier: "Friendlier",
  email_suggestion_overwrite: "Replace the text you already typed with this suggestion?",
  email_suggestion_replace: "Replace",
  email_suggestion_check_recipient: "Please check the greeting — the recipient could not be confirmed.",
  email_suggestion_review: "Review this draft before sending. It may include assumed details.",
  email_suggestion_error: "Could not load suggestions.",
  startup_screen_label: "Startup Screen",
  startup_screen_info: "Choose which screen opens when you start Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Messages",
  startup_screen_saved: "Startup screen updated",
  email_on: "Email notification chats",
  email_on_grp: "Email notification",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Activate or deactivate email notifications for this project. This option is only available when \"Email notification chats\" is enabled via personal settings.",
  info_val: "You'll get an email when a new chat message isn't read within a short time. You can turn it off for individual projects or chats in their settings or in the chat group info.",
  email_groups: "Activate or deactivate email notifications for this chat. This option is only available when \"Email notification chats\" is enabled via personal- and project settings.",
  add_update_email: "Add/Update Email",
  add_update_email_for_notifications: "Add/update email for email notifications",
  text_to_verifiy: "The \"Email notification chats\" option can only be enabled if you have a verified email address on file.",
  stored_email: "Stored email: ",
  verify_email: "Confirmation pending!",
  verified: "Verified",
  join_call:"Join",
  call_is_started:"Call is started",
  start_chat:"Start Direct-Chat?",
  project_rooms:"Projects",
  download_selected:"Download",
  download_to_folder: "Download to folder",
  download_as_zip: "Download as ZIP",
  media_download_progress: "Downloading {current} of {total}",
  media_downloaded_on: "Images downloaded on {datetime}",
  docs_downloaded_on: "Documents downloaded on {datetime}",
  media_auto_download: "Automatic media download",
  media_auto_download_hint: "New images and docs are saved at 8:00 PM",
  media_auto_download_info: "Choose a folder once. New images and documents from this chat or project are saved there automatically every day at 8:00 PM. If Kjuup is closed at that time, the download runs the next time you open the app.",
  media_auto_download_unsupported: "Folder selection needs Chrome or Edge",
  media_auto_download_continue: "Allow folder access to continue",
  media_export_server: "Media export server",
  media_export_server_info: "Connect one WebDAV or SFTP server. Each chat and project can then export new media into its own folder every evening at 20:00.",
  media_export_protocol: "Protocol",
  media_export_host: "Host",
  media_export_port: "Port",
  media_export_username: "Username",
  media_export_password: "Password",
  media_export_base_path: "Base path (optional)",
  media_export_test: "Test connection",
  media_export_test_ok: "Connection successful",
  media_export_test_fail: "Connection failed",
  media_export_saved: "Connection saved",
  media_export_disconnect: "Disconnect",
  media_export_disconnect_confirm: "Disconnect this file server?",
  media_export_folder: "Nightly media export",
  media_export_folder_placeholder: "/Projects/Alpha",
  media_export_nightly_hint: "New images, videos, and documents are uploaded at 20:00",
  media_export_nightly_info: "New images, videos, and documents are uploaded every evening at 20:00 to the folder path on the company file server. The app does not need to be open.",
  media_export_admin_required: "A file server must be connected in the Admin Panel.",
  media_export_readonly: "Exports nightly to {path}",
  media_export_last_error: "Last export failed",
  change: "Change",
  add_employee_confirm: 'Are you sure you want to add this user to the company?',
  invalid_deeplink: "Invalid deeplink URL. Missing required parameters.",
  deeplink_error: "Unable to process deeplink. Please try again later.",
  // Reply functionality translations
  reply: "Reply",
  reply_enter: "Enter reply...",
  reply_sent_successfully: "Reply sent successfully",
  reply_failed: "Failed to send reply",
  reply_failed_generic: "Failed to send reply. Please try again.",
  replying_to_message: "Replying to message",
  cancel_reply: "Cancel reply",
  voice_message: "Voice message",
  send: "Send",
  cancel: "Cancel",
  type_your_reply: "Type your reply...",
  
  // Auto-suggestion translations
  suggested_replies: "Suggested Replies",
  suggestions_error: "Failed to load suggestions",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Just a moment. Your text is being prepared individually for you.",
  loading_chat_message: "Loading chat...",
  
  // Manual ToDo translations
  create_todo: "Create ToDo",
  create_todo_confirmation: "Do you want to create a ToDo from this message?",
  select_project_required: "Please select a project/group",
  only_assigned_can_change_status: "Only assigned users can change status",
  todo_summary: "Summary",
  todo_summary_placeholder: "Enter todo summary...",
  todo_date: "Date",
  todo_time: "Time",
  deadline: "Deadline",
  todo_date_hint: "Leave empty to use the original message date/time",
  todo_created_success: "ToDo created successfully",
  extracting_message: "Extracting message...",
  creating_todo: "Creating ToDo...",
  bookmark_todo_creating: "Bookmarked task is being created...",
  navigating_to_todo: "Navigating to ToDo...",
  todo_creation_failed: "Failed to create ToDo",
  create: "Create",
  
  image: "image",
  images: "images",
  remove_all_images: "Remove all images",
  remove_image: "Remove image",
  remove_document: "Remove document",
  remove_recording: "Remove recording",
  play_recording: "Play recording",
  upload_image: "Upload image",
  upload_document: "Upload document",
  record_audio: "Record audio",
  stop_recording: "Stop recording",
  stop_recording_text: "Stop recording",
  please_remove_current_attachment: "Please remove current attachment to",
  please_upload_image_file: "Please upload a valid image file",
  please_upload_valid_document: "Please upload a valid document file",
  searching_messages: "Searching messages...",
  loading_more: "Loading more...",
  loading_more_users: "Loading more users...",
  load_more_users: "Load More Users",
  no_more_users_to_load: "No more users to load",
  no_messages_found: "No messages found",
  try_different_keyword: "Try a different keyword or check your spelling.",
  search_messages: "Search messages, chats, ToDo's, projects and users...",
  search_messages_with_email: "Search messages, emails, chats, ToDo's, projects and users...",
  search_describe: "Describe what you're looking for…",
  search_describe_with_email: "Describe what you're looking for…",
  search_describe_examples: "e.g. messages from Martin about invoice · user Martin Langen · or just a keyword",
  search_describe_examples_with_email: "e.g. emails from ml@bl2020.com about password · messages from Martin about invoice · user Martin Langen",
  search_intent_understood: "Searching",
  search_intent_emails: "Emails",
  search_intent_messages: "Messages",
  search_intent_user: "User",
  search_submit: "Search",
  search_groups: "Groups",
  search_chat_groups: "Chat-Groups",
  search_project_room: "Project",
  search_messages_tab: "Messages",
  search_result_kjuup_chat: "Messages Kjuup Chat",
  search_users_tab: "Users",
  search_documents_tab: "Documents",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "No files",
  no_documents_available: "No documents",
  searching_groups: "Searching groups...",
  searching_rooms: "Searching projects...",
  searching_users: "Searching users...",
  no_groups_found: "No groups found",
  no_rooms_found: "No projects found",
  no_users_found: "No users found",
  search_emails_tab: "Email",
  searching_emails: "Searching emails...",
  no_emails_found: "No emails found",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",
  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  search_email_filter_all: "All",
  search_email_filter_content: "Content",
  search_email_filter_addresses: "Addresses",
  search_email_filter_attachments: "Attachments",
  search_email_filter_has_attachments: "Has attachments",
  search_email_filter_unread: "Unread",
  search_email_combo_placeholder: "In emails of (optional)…",
  search_email_combo_content_placeholder: "Search inside those emails…",
  search_email_combo_hint: "Searching within emails of",
  search_email_combo_containing: "containing",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  search_todos_tab: "ToDo",
  no_todos_found: "No ToDos found",
  todo: "ToDo",
  np_todo: "No ToDo's",
  move_to_todo: "Save as ToDo",
  remove_todo: "Do you really want to remove the ToDo?",
  remove_all_todo: "Remove all ToDo's",
  remove_all_todo_confirm: "Do you really want to remove all ToDo's?",
  add_to_todo: "Add to ToDo",
  remove_from_todo: "Remove from ToDo",
  confirm: "Confirm",
  ok: "Ok",
  read_more: "Read more",
  show_less: "Show less",
  show_more: "Show more",
  audio: "Audio",
  video: "Video",
  // Notification Settings
  browser_notifications: "Desktop notifications",
  browser_notifications_desc: "Get notified of new messages even when Kjuup is in the background.",
  browser_notifications_blocked: "Notifications are blocked in your browser. Allow them for this site in the address bar, then try again.",
  browser_notifications_unsupported: "Desktop notifications are not supported in this browser.",
  browser_notifications_error: "Could not update desktop notifications",
  notification_schedule: "Notification schedule",
  notification_schedule_desc: "You'll only receive push and email notifications during the hours you choose. Outside of those times, they will be paused.",
  company_notification_schedule_desc: "Set notification times for all company members. This will overwrite the personal notification settings of every member.",
  learn_more: "Learn more",
  allow_notifications: "Allow notifications:",
  every_day: "Every day",
  weekdays: "Weekdays (Monday through Friday)",
  custom: "Custom",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  to: "to",
  notification_settings: "Notifications",
  notification_settings_saved: "Notification settings saved successfully",
  notification_settings_error: "Failed to save notification settings",
  unavailability_note: "Unavailability Note",
  unavailability_description: "Set an out-of-office note. While active, the note is shown to others in all your chats and notifications are paused.",
  unavailability_start_date: "Start date",
  unavailability_end_date: "End date",
  unavailability_message: "Message",
  unavailability_message_hint: "Use {endDate} as a placeholder for your return date.",
  unavailability_replacement: "Replacement Contact",
  unavailability_replacement_placeholder: "Enter user ID for urgent requests",
  unavailability_replacement_current: "Current replacement",
  unavailability_replacement_hint: "If set, a link to contact this person for urgent matters will be shown in your unavailability note.",
  unavailability_replacement_none: "No replacement (optional)",
  unavailability_contact_urgent: "For urgent requests contact",
  unavailability_default_message: "I am currently out of the office and do not have access to Kjuup. I will be available again from {endDate} and will get back to you then.",
  unavailability_save: "Save",
  unavailability_deactivate: "Deactivate",
  unavailability_active_until: "Active until",
  unavailability_saved: "Unavailability note saved",
  unavailability_save_error: "Failed to save unavailability note",
  unavailability_deactivated: "Unavailability note deactivated",
  unavailability_end_date_required: "End date is required",
  start_time_before_end_time: "Start time must be before end time",
  loading: "Loading",
  disabled: "Disabled",
  enable: "Enable",
  disable: "Disable",
  forwarded: "Forwarded",
  message_forwarded: "Message forwarded!",
  // Schedule Article
  schedule_article_post: "Schedule article post",
  date: "Date",
  time: "Time",
  scheduled_for_publication: "Scheduled for publication",
  scheduled_and_drafts: "Scheduled articles and drafts",
  article_scheduled: "Scheduled",
  article_draft: "Draft",
  article_drafts: "Drafts",
  no_scheduled_or_drafts: "No scheduled articles or drafts",
  no_scheduled_articles: "No scheduled articles",
  no_draft_articles: "No drafts",
  save_as_draft: "Save as Draft",
  article_will_be_published_on: "Article will be published on:",
  reset_selection: "Reset Selection",
  continue: "Continue",
  cancel: "Cancel",
  // Member Selection
  error_loading_members: "Error loading members",
  please_fill_all_fields: "Please fill all fields",
  invalid_email: "Invalid email address",
  member_added_successfully: "Member added successfully",
  error_onboarding_user: "Error adding user",
  error_creating_chat: "Error creating chat",
  error_creating_group: "Error creating group",
  new_group: "New Group",
  please_select_or_enter_group_name: "Please select a group or enter a group name",
  please_select_or_enter_room_name: "Please select a project or enter a project name",
  error_creating_room: "Error creating project",
  error_opening_chat: "Error opening chat",
  privacy_modal_text: "Select \"Private\" only if the chat contains no relevant professional content for the project manager.",
  not_private: "Not private",
  private: "Private",
  error_loading_groups: "Error loading groups",
  automatic_chat_export: "Automatic chat export",
  automatic_chat_export_info: "After activation, the chat history will be automatically sent to the specified email address each month.",
  automatic_chat_export_no_email: "To activate automatic chat export, you first need to add an email address. You can add your email address in the personal settings.",
  enter_email: "Enter E-Mail",
  update: "Update",
  confirm: "Confirm",
  export_to_email: "The export goes to the following E-Mail.",
  start_chat_button:"New message",
  start_direct_message: "Start direct message?",
  matching_existing_chats: "Matching existing chats",
  subject: "Subject",
  add_subject: "Add subject",
  chat_subject: "Chat Subject:",
  set_project_room: "Set project",
  matching_existing_project_rooms: "Matching existing projects",
  name_project_room: "Project name",
  professional_or_private: "Professional or private",
  professional: "Professional",
  privacy_modal_text_updated: "Only select \"Private\" if the chat does not contain relevant professional content for project managers. Private chats are not visible to project managers.",
  create_internal_chat: "External - or internal chat?",
  internal_chat_description: "Only employees of your company can be added to internal chats.",
  yes: "Yes",
  no: "No",
  chat_is_being_created: "Chat is being created...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Do you really want to discard changes to this article?",
  save_article_as_draft_confirm: "Do you want to save this article as a draft?",
  please_enter_article_title: "Please enter article title first.",
  please_add_mandatory_fields: "Please add all mandatory fields",
  product_label: "Product:",
  no_companies_found: "No companies found",
  visible_to_all_followers: "Visible to all Kjuup members",
  only_visible_to_employees: "Only visible to employees",
  something_went_wrong: "Something went wrong, Please try again",
  please_select_department: "Please select department/location",
  schedule: "Schedule",
  please_select_future_date_time: "Please select a future date and time for scheduling the article.",
  please_select_different_date_time: "Please select a different date or time to schedule the article.",
  please_select_later_time: "Please select a time later than the current time for today.",
  unpin_article: "Unpin article",
  pin_article: "Pin article",
  and: "and",
  others: "others",
  at: "at",
  // Chat mute/unmute translations
  mute: "Mute",
  unmute: "Unmute",
  chat_muted_successfully: "Chat muted successfully",
  chat_unmuted_successfully: "Chat unmuted successfully",
  mute_chat_confirm: "Do you really want to mute this chat? You will no longer receive notifications for new messages.",
  unmute_chat_confirm: "Do you really want to unmute this chat? You will receive notifications for new messages again.",
  please_select_group_to_forward: "Please select group to forward message",
  // Company translations
  record_not_found: "Record not found!",
  please_select_position: "Please select position",
  delete_article_confirm: "Are you sure you want to delete this article?",
  delete_company_service_confirm: "Are you sure you want to delete the company service?",
  block_translation_confirm: "Do you really want to block automatic translation in projects for all members of the company",
  unblock_translation_confirm: "Do you really want to unblock automatic translation in projects for all members of the company",
  please_select_file: "Please select a file to upload",
  role_in_building_industry: "Role in the building industry*",
  invalid_email_address: "Invalid Email Address",
  please_enter_password: "Please enter password",
  password_change_email_sent: "An email has been sent to your Kjuup email. Please confirm your new password by clicking the confirmation link in the email.",
  please_enter_username: "Please enter username",
  username_same_as_before: "Username can't be the same as before",
  profile_deleted_successfully: "Profile Deleted Successfully",
  hardware_requirements: "Hardware Requirements",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU speed min. 2GHz<br/>• Windows 7 or higher / all macOS versions",
  submitting: "Submitting...",
  signing_in: "Signing in...",
  please_enter_service_name: "Please enter service name",
  something_went_wrong_error: "Aaaah! Something went wrong...",
  something_went_wrong_try_again: "Sorry, something went wrong there. Try again",
  position_label: "Position:",
  loading_room: "Loading project...",
  navigating_to_room: "Navigating to the project",
  loading_chat: "Loading chat...",
  translate: "Translate",
  show_original: "Show Original",
  show_translation: "Show translation",
  click_to_show_original: "Click to show original",
  click_to_show_translation: "Click to show translation",
  saving: "Saving...",
  language_selection_info: "The language selection is used for all email confirmations related to the company.",
  video_call: "Video call",
  audio_call: "Audio call",
  // Navigation bar labels
  nav_call: "Call",
  nav_home: "Home",
  nav_messages: "Messages",
  nav_todo: "Tasks",
  nav_rooms: "Projects",
  nav_all_rooms: "All Projects",
  pinned_rooms_max: "You can pin up to 10 projects.",
  pinned_room_unpin: "Unpin",
  pinned_rooms_drop: "Drag your project here for quick selection",
  nav_profile: "Profile Settings",
  nav_company: "Company",
  nav_company_documents: "Documents",
  nav_logout: "Logout",
  // Create message dialog
  add_member_title: "Add Member",
  continue_btn: "Continue",
  search_placeholder: "Search",
  no_members_found: "No members found",
  no_groups_found: "No groups found",
  no_rooms_found: "No projects found",
  unnamed_group: "Unnamed Group",
  unnamed_room: "Unnamed Project",
  all_members: "All",
  room_label: "Project:",
  subject_label: "Subject:",
  no_members: "No members",
  // Loading states for room creation
  creating_structure: "Creating your structure",
  opening_chat: "Opening the chat",
  please_wait: "Please wait...",
  // Loading states for company join
  sending_request: "Sending request",
  updating_profile: "Updating profile",
  // ToDo page translations
  loading_todo: "Loading ToDo...",
  task_updated: "Task updated",
  error_updating_task: "Error updating task",
  task_deleted: "Task deleted",
  error_deleting_task: "Error deleting task",
  delete_task_confirm: "Are you sure you want to delete this task?",
  delete_bookmarked_priority_confirm: "Are you sure you want to delete this bookmarked task?",
  delete_multiple_tasks_confirm: "Are you sure you want to delete {count} ToDos?",
  delete_selected_count: "Delete ({count})",
  todo_multi_delete: "Delete multiple",
  todo_multi_delete_hint: "Select ToDos to delete",
  todos_deleted_count: "{count} ToDos deleted",
  pro_todo_delete_previous: "Delete all",
  pro_todo_previous_title: "Delete {{n}} overdue tasks?",
  pro_todo_previous_text: "All your open tasks of earlier days will be deleted.",
  pro_todo_previous_skipped: "{{n}} assigned to you by others stay.",
  pro_todo_previous_none: "No overdue tasks",
  pro_todo_previous_none_own: "The overdue tasks were assigned to you by others and can only be deleted by them.",
  todos_deleted_partial: "{ok} ToDos deleted, {fail} failed",
  delete_only_own: "You can only delete ToDos you created",
  description_label: "Description",
  description_placeholder: "Enter description...",
  date_time_label: "Date & Time",
  save_hint: "Ctrl+Enter to save, Esc to cancel",
  edit_label: "Edit",
  delete_label: "Delete",
  todo_list_title: "Tasks",
  tasks_count: "tasks",
  search_placeholder_todo: "Search...",
  select_task_to_open_chat: "Select a task to open the chat",
  today: "Today",
  yesterday: "Yesterday",
  time_suffix: "", // Empty for English (24h format doesn't need suffix)
  from_chat: "Source ToDo",
  assigned_to: "Assigned to",
  assign_users: "Assign users",
  assigned_users: "Assigned Users:",
  no_users_assigned: "No users assigned",
  assign: "Assign",
  assign_to: "Assign to...",
  navigate_to_chat: "Navigate to Chat",
  navigate_to_email: "Navigate to email",
  navigate_to_source: "Navigate to source",
  show_original_message: "Show source",
  hide_original_message: "Hide source",
  status_pending: "Pending",
  status_in_progress: "In Progress",
  status_completed: "Completed",
  show: "Show",
  close: "Close",
  // Additional ToDo translations
  todo_beta: "BETA",
  todo_project_label: "Project assignment:",
  todo_room_none: "No assignment",
  todo_room_clear: "Remove project assignment",
  todo_chat_label: "Chat:",
  todo_assigned_by: "Assigned by:",
  todo_assigned_push: "Assigned ToDo:",
  todo_assigned_push_empty: "A new ToDo was assigned to you.",
  todo_clear_all: "Clear all",
  todo_unknown: "Unknown",
  filter_all: "All",
  filter_assigned_to_me: "My Tasks",
  filter_assigned_by_me: "Delegated",
  completed_by: "Completed by:",
  verify_completion: "Verify",
  back_into_in_progress: "Back into in progress",
  unassign_todo: "Unassign ToDo",
  unassign_label: "Unassign",
  me: "Me",
  search_or_select_project: "Search or select a project...",
  // Confirmed ToDo and History translations
  status_confirmed: "Confirmed",
  history: "History",
  marked_as: "Marked as",
  at_date: "at",
  at_time: "at",
  time_suffix: "",
  all_todos: "Open ToDo's",
  confirmed_todos: "Confirmed ToDo's",
  filter_pending: "Pending",
  filter_confirmed: "Confirmed",
  my_list: "My Day",
  todo_adjust_list: "Adjust list",
  apply: "Apply",
  move_back_in_progress: "Move back in progress",
  no_history_yet: "No history yet",
  todo_status_updated: "Updated todo status from {from} to {to}",
  todo_status_updated_from: "from",
  todo_status_updated_to: "to",
  // Log description translations
  log_todo_created: "ToDo created",
  log_todo_confirmed: "ToDo confirmed",
  log_todo_deleted: "ToDo deleted",
  log_todo_updated: "ToDo updated",
  log_description_updated: "Description updated",
  log_deadline_updated: "Deadline updated",
  log_assigned_to: "Assigned to {name}",
  log_unassigned_from: "Unassigned from {name}",
  log_assignment_added: "Assignment added: {name}",
  log_assignment_removed: "Assignment removed: {name}",
  log_status_updated: "Status changed from {from} to {to}",
  log_status_changed: "Status changed",
  log_status_changed_to: "Status changed to {status}",
  log_changed_status_to: "Changed the status to:",
  log_for_user: "for user:",
  log_user_updated_status: "User updated their todo status",
  log_changed_date_to: "Changed the date to:",
  log_changed_description_to: "Changed the description to:",
  log_moved_to: "Moved to {status}",
  // ToDo filter translations
  todo_filters: "Filters",
  todo_filter_by_project: "Filter by project",
  todo_status: "Status",
  todo_assignment: "Assignment",
  todo_filter_by_user: "Filter by Assigned Person",
  todo_active_filters: "Active Filters:",
  todo_progress: "Progress",
  todo_my_list_empty: "Your day is empty",
  todo_my_list_empty_hint: "Click “Adjust list” to add tasks",
  create_poll: "Poll",
  poll_question_label: "QUESTION",
  poll_question_placeholder: "Ask a question",
  poll_options_label: "OPTIONS",
  poll_option: "Option",
  poll_add_option: "Add option",
  poll_allow_multiple: "Allow multiple answers",
  poll_multiple_allowed: "Select one or more options",
  poll_select_option: "Select one option",
  poll_view_votes: "View votes",
  poll_vote_singular: "vote",
  poll_vote_plural: "votes",
  poll_votes: "Poll votes",
  poll_no_votes_yet: "No votes yet",
  transcript_label: "Transcript",
  ai_generated_transcription: "AI-generated transcription",
  transcript_start: "Transcribe voice message",
  transcript_transcribing: "Transcribing...",
  transcript_show: "Show transcript",
  transcript_hide: "Hide transcript",
  transcript_redo: "Redo transcription",
  transcript_failed: "Transcription failed",
  transcript_no_result: "No transcript returned",
  transcript_step_listening: "Listening to voice message...",
  transcript_step_processing: "Transcription in progress...",
  transcript_step_creating: "Creating text...",
  ai_transcript_tab: "AI-Transcript",
  ai_transcript_info: "Only available for voice messages created after 09.03.2026.",
  no_transcript_available: "No transcript available.",
  transcript_more: "...more",
  transcript_less: "...less",
  ki_transcript_voice_message: "KI-Transcript of Voice Message",
  ki_image_analysis: "AI-Powered Image Analysis",
  document_analysis: "Document Analysis",
  type_message: "Type a message",
  email_tab_messages: "Messages",
  email_tab_email: "Email",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Email Accounts",
  calendar_sync_title: "Calendar Sync",
  calendar_sync_info: 'Automatically sync all Kjuup ToDo\'s with your calendar.',
  calendar_connect_google: "Connect Google Calendar",
  calendar_connect_outlook: "Connect Outlook Calendar",
  calendar_connect_apple_caldav: "Connect Apple / CalDAV",
  calendar_connect: "Connect",
  calendar_connected: "Calendar connected",
  calendar_connect_failed: "Calendar connection failed",
  calendar_disconnected: "Calendar disconnected",
  calendar_disconnect_confirm: "Disconnect this calendar? Existing calendar events will be left as-is; sync will stop.",
  calendar_no_accounts: 'No calendar connected yet.',
  calendar_sync_enabled: "Sync enabled",
  calendar_on_complete: "When ToDo is completed",
  calendar_on_complete_delete: "Remove calendar event",
  calendar_on_complete_mark: "Mark event as done",
  calendar_target: "Target calendar",
  calendar_refresh_list: "Refresh",
  calendar_auth_error: "Reconnect required",
  calendar_apple_hint: "Use your Apple ID email and an app-specific password from appleid.apple.com.",
  calendar_server_url: "CalDAV server URL",
  calendar_username: "Username / email",
  calendar_password: "Password / app-specific password",
  calendar_caldav_required: "Username and password are required.",
  calendar_caldav_server_required: "Server URL is required for CalDAV.",
  calendar_auth_url_failed: "Failed to get authorization URL.",
  calendar_syncing: "Updating from calendar…",
  calendar_sync_up_to_date: "Calendar up to date",
  calendar_sync_failed: "Sync failed",
  calendar_sync_complete: "Calendar updated",
  calendar_sync_now: "Sync now",
  calendar_reconnect: "Reconnect",
  email_connect_gmail: "Connect Gmail",
  email_connect_outlook: "Connect Outlook",
  email_no_accounts: "No email accounts connected",
  email_no_accounts_hint: "Connect an email account in your profile settings",
  email_no_messages: "No emails",
  email_from: "From",
  email_to: "To",
  email_subject: "Subject",
  email_disconnect: "Disconnect",
  email_disconnect_confirm: "Are you sure you want to disconnect this email account? All synced emails will be removed.",
  email_account_disconnected: "Email account disconnected successfully",
  email_account_disconnect_failed: "Failed to disconnect account",
  email_connecting: "Connecting...",
  email_account_connected: "Account connected successfully",
  email_connection_error: "Connection issue",
  email_connection_error_hint: "This account could not be synced. Reconnect to restore incoming email.",
  email_reconnect: "Reconnect",
  email_edit_settings: "Edit settings",
  email_imap_edit_title: "Edit IMAP account",
  email_imap_edit_hint: "Update the email address or password, then save to reconnect this account.",
  email_imap_save: "Save & reconnect",
  email_reconnect_banner: "One or more email accounts need to be reconnected.",
  email_reconnect_manage: "Fix in settings",
  email_connection_warning: "The email connection for {email} is not working properly. Reconnect to keep receiving new emails.",
  email_connection_warning_multi: "Email connections for {emails} are not working properly. Reconnect to keep receiving new emails.",
  email_connected_accounts: "Connected Accounts",
  email_sync_info: "When connecting an email account, emails from the last month are synchronised by default. You can extend the sync period below.",
  email_sync_3_months: "Sync last 3 months",
  email_sync_6_months: "Sync last 6 months",
  email_syncing: "Syncing...",
  email_sync_already_done: "{months} months already synced",
  email_sync_more: "Sync more months",
  email_sync_retry: "Re-sync months",
  email_sync_all_done: "All months synced",
  email_sync_backfill_started: "Re-syncing older emails — this can take several minutes for large inboxes…",
  email_sync_backfill_hint: "Fill missing older emails in this period",
  email_sync_retry_3_months: "Re-sync last 3 months",
  email_sync_retry_6_months: "Re-sync last 6 months",
  email_syncing_account: "Syncing account, this may take a few minutes…",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_add_account: "Add Account",
  email_folder_inbox: "Inbox",
  email_folder_spam: "Spam",
  email_folder_drafts: "Drafts",
  email_folder_sent: "Sent Items",
  email_folder_deleted: "Deleted Items",
  email_folder_archive: "Archive",
  email_folder_outbox: "Outbox",
  email_custom_folders: "Folders",
  email_create_folder: "New Folder",
  email_delete_folder: "Delete Folder",
  email_folder_name_placeholder: "Folder name",
  email_folder_created: "Folder created",
  email_folder_deleted: "Folder deleted",
  email_move_to: "Move to",
  email_moved_to_folder: "Moved to folder",
  email_move_to_inbox: "Move to Inbox",
  email_confirm_delete_folder: "Are you sure you want to delete this folder?",
  email_refresh: "Refresh",
  email_folder_not_synced: "This folder is not automatically synced.",
  email_sync_folder: "Sync now",
  email_go_to_settings: "Go to Settings",
  email_date: "Date",
  email_reply: "Reply",
  email_forward: "Forward",
  email_copy_text: "Copy text",
  email_more_actions: "More actions",
  email_text_copied: "Copied!",
  email_text_copy_failed: "Could not copy the text.",
  email_delete: "Delete",
  email_not_spam: "Not Spam",
  email_not_spam_success: "Email moved to inbox.",
  email_not_spam_failed: "Failed to move to inbox.",
  email_delete_confirm: "Are you sure you want to delete this e-mail?",
  email_delete_from_folder: "Are you sure you want to delete from {folder}?",
  email_delete_permanent_from_folder:
    "Are you sure you want to permanently delete from {folder}? This action cannot be undone.",
  email_save_draft_confirm: "Do you want to save this email as a draft?",
  email_save_draft: "Save Draft",
  email_discard: "Discard",
  email_back_to_compose: "Back to compose",
  email_draft_saved: "Draft saved.",
  email_saving_draft: "Saving draft...",
  email_draft_save_failed: "Failed to save draft.",
  email_loading: "Loading emails...",
  email_imap_title: "IMAP",
  email_imap_hint: "Connect any email account via IMAP.",
  email_imap_user: "Email",
  email_imap_password: "Password",
  email_imap_connect_btn: "Connect IMAP account",
  email_imap_required: "Please enter email and password.",
  email_imap_failed: "IMAP connection failed.",
  email_imap_manual_toggle: "Manual server settings",
  email_imap_host: "IMAP Server (e.g. imap.ionos.de)",
  email_imap_port: "Port",
  email_imap_incoming: "Incoming Mail (IMAP)",
  email_smtp_outgoing: "Outgoing Mail (SMTP)",
  email_smtp_host: "SMTP Server (e.g. smtp.ionos.de)",
  email_smtp_port: "Port",
  email_send_btn: "Send",
  email_sent: "Email sent.",
  email_sending: "Sending email...",
  deleting_emails: "Deleting email...",
  marking_unread: "Marking as unread...",
  email_send_failed: "Failed to send email.",
  email_compose_to_required: "Recipient (To) is required.",
  email_compose_body_required: "Please enter a subject or message body.",
  email_compose_placeholder: "Write your message...",
  email_original_message: "Original message",
  email_forwarded_message: "Forwarded message",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search in this folder",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Select",
  email_attachment_singular: "Attachment",
  email_attachment_plural: "Attachments",
  email_back: "Back",
  email_download: "Download",
  email_download_all: "Download all",
  email_download_all_zip: "Download all as ZIP",
  email_download_failed: "Download failed",
  email_close: "Close",
  email_preview: "Preview",
  email_preview_not_available: "Preview not available",
  email_preview_failed: "Preview not available",
  email_loading_preview: "Loading preview...",
  email_no_subject: "(No subject)",
  email_mark_unread_failed: "email(s) could not be marked as unread.",
  email_delete_failed: "email(s) could not be deleted.",
  // Email-to-room classification
  email_classify_banner: "{count} email(s) from new senders need classification",
  email_classify_banner_inline: "{count} email(s) from new senders — assign each to a project or mark as spam below",
  email_marked_spam: "Moved to Spam",
  email_classify_review: "Review",
  email_classify_title: "Classify new sender",
  email_classify_question_project: "Is this email related to a project?",
  email_project_name: "Project name",
  email_classify_suggested: "Suggested",
  email_remember_sender: "Remember this sender for future emails",
  email_account_default_project: "Always associate this account's emails to this project",
  email_classify_associate: "Associate to project",
  email_associating_to_project: "Saving email to project...",
  email_associating_spam: "Moving to Spam...",
  email_finding_similar: "Looking for similar emails...",
  email_associating_similar: "Assigning similar emails...",
  email_classify_missing: "Unassigned",
  email_tag_daily_briefing: "Daily report",
  email_project_navigate: "Navigate to project",
  email_project_change: "Change project association",
  email_project_remove: "Remove project association",
  email_project_removed: "Project association removed",
  email_classify_question_spam: "Is this SPAM or Advertising?",
  email_classify_mark_spam: "Move to Spam",
  email_classify_skip: "Skip for now",
  email_classify_need_project: "Please enter a project name",
  email_classify_refile_question: "Should I file this email in project '{name}' again?",
  email_classify_refile_yes: "Yes, file in '{name}'",
  email_classify_save_question: "Should I save this email in project '{name}'?",
  email_classify_save_yes: "Yes, save in '{name}'",
  email_saved_to_project: "Email saved to project",
  email_saved_to_project_similar: "Email saved to project. {count} similar emails were also assigned.",
  email_in_project: "In project",
  email_classify_choose_other: "Choose a different project",
  email_new_room_title: "Create new project",
  email_new_room_name: "Project name",
  email_new_room_type: "Project type",
  email_new_room_external: "External",
  email_new_room_internal: "Internal",
  email_new_room_company: "Select company connection",
  email_new_room_company_info: "Choose the company connection you want to be listed with in the project. This is shown to other members.",
  email_new_room_kjuup_company: "Select Kjuup+ company",
  email_new_room_kjuup_company_info: "The internal project will belong to this Kjuup+ company.",
  email_new_room_internal_unavailable: "Join a Kjuup+ company to create internal projects",
  email_new_room_create: "Create project & save email",
  email_room_tab: "Email",
  email_room_tab_all: "All",
  email_room_tab_todos: "Tasks",
  email_room_tab_briefings: "Daily report",
  email_room_all_empty: "No messages in this project yet",
  email_room_briefings_empty: "No daily reports in this project",
  email_room_empty: "No emails associated added to this project",
  email_room_sent_empty: "No sent emails in this project",
  email_room_drafts_empty: "No drafts in this project",
  email_room_inbox: "Inbox",
  email_room_sent: "Sent",
  email_room_drafts: "Drafts",
  email_room_remove: "Remove from project",
  email_room_remove_confirm: "Remove this email from the project?",
  email_room_briefing_remove_confirm: "Do you really want to remove this daily report?",
  email_room_removed: "Email removed from project",
  email_room_briefing_removed: "Daily report removed",
  email_compose_project: "Project association in Kjuup",
  email_compose_project_info:
    "This information is only visible to you and will not be sent with the email.",
  email_compose_project_placeholder: "Project name",
  email_compose_create_room: "Create project",
  email_compose_creating_room: "Creating project...",
  email_no_sender: "(unknown sender)",
  email_no_recipient: "(no recipient)",
  email_attachments_tab: "E-MAIL",
  select_attachments: "Select attachments",
  email_attachments_empty: "No email attachments yet",
  email_move_to_room: "Move to project",
  email_attachment_moved: "Email attachment moved",
  email_attachment_removed: "Email attachment removed",
  email_attachment_remove_confirm: "Remove the selected email attachment(s) from this project?",
  email_no_other_rooms: "No other projects available",
  email_classify_rules_title: "Email classification rules",
  email_default_project_per_account: "Default project per account",
  email_sender_rules: "Sender rules",
  email_spam_blocklist: "Spam blocklist",
  email_no_default: "None",
  email_select_project: "Select project",
  info: "Info",
  email_default_project_info:
    "When an email account is linked to a specific project, ALL incoming emails from that account are automatically associated to that project — you won't be asked to classify them. Leave it empty to classify each email individually.",
  email_account_project_title: "Link account to project?",
  email_account_project_question:
    "Is this email account used exclusively for one specific project? If so, please select the project. All incoming emails will then be automatically assigned to that project.",
  email_account_project_name_placeholder: "Name",
  email_account_create_room: "Create new project",
  email_account_create_company: "Select company",
  email_account_create_submit: "Create project & link",
  email_account_project_link: "Link account to project",
  email_account_project_skip: "No, classify each email individually",
  email_account_project_linked: "Account linked to project",
  project_confirm_title: "Did you mean this project?",
  project_confirm_text:
    'The name "{typed}" is very similar to the existing project "{existing}". Do you want to use the existing project, or create a new one?',
  project_confirm_use_existing: 'Use "{name}"',
  project_confirm_create_new: 'Create new "{name}"',
  attachment: "attachment",
  attachments: "attachments",
  media_send_disabled: "Disabled by admin.",
  todo_bookmarked: "Task has been bookmarked",
  bookmarked_todos: "Bookmarked tasks",
  needs_date: "Assign date",
  needs_date_hint: "Set a date to plan this ToDo",
  bookmarked_no_mylist: "Bookmarked tasks cannot be added to My List",
  bookmark_removed: "Bookmarked task removed",
  bookmark_already_todo: "This ToDo has already been edited and will be kept",
  new_label: "New",
  no_new_todos: "No new ToDo's",
  filter_all: "All",
  filter_email: "Email",
  filter_reports: "Daily reports",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Direct Messages",
  my_notes: "My Space",
  pin_chat: "Pin",
  unpin_chat: "Unpin",
  filter_internal_groups: "Internal Group Chats",
  filter_external_groups: "External Group Chats",
  filter_group_chats: "Group Chats",
  filter_groups_internal: "Internal",
  filter_groups_external: "External",
  filter_unread_only: "Unread only",
  email_select_all: "Select all",
  email_deselect_all: "Deselect all",
  email_reply_all: "Reply all",
  email_reply_placeholder: "Type your reply...",
  email_forward_placeholder: "Add a message...",
  email_edit_draft: "Edit Draft",
  email_attach: "Attach",
  email_attachment_from_original: "From original message",
  email_remove: "Remove",
  email_drop_files: "Drop files to attach",
  email_loading_attachments: "Loading attachments...",
  email_archive: "Archive",
  mark_unread: "Mark as unread",
  mark_read: "Mark read",
  email_all_accounts: "All Accounts",
  email_error: "Error",
  email_delete_email_failed: "Failed to delete email.",
  enter_url: "Enter URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Subscribe now',
  kjuup_io_subscribe_now_short: 'Subscribe',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MONTH FREE TRIAL',
  pro_auth_register_kjuup_io_title: 'Kjuup.io registration',
  pro_auth_register_kjuup_io_sub: 'Your free Kjuup.io trial starts right away with your account – no payment details needed. We will send you a link to confirm your email address.',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'No payment today. No credit card details are requested before your paid subscription starts.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now – no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Manage all email accounts directly in Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI writes replies – you just confirm',
  kjuup_io_feature_tasks: 'Tasks & calendar always kept up to date automatically',
  kjuup_io_company_managed_title: 'Managed by your company',
  kjuup_io_company_admins_title: 'Your company admins',
  kjuup_io_company_admins_hint: 'They can assign you a Kjuup.io seat in the Admin Panel.',
  kjuup_io_company_managed_body:
    'Kjuup.io for your Kjuup+ company is booked and billed in the Admin Panel. Contact {admins} to get access.',
  kjuup_io_company_managed_body_short:
    'Ask your company admin to assign you a Kjuup.io seat in the Admin Panel.',
  kjuup_io_company_managed_body_short_admins:
    'Ask {admins} to assign you a Kjuup.io seat in the Admin Panel.',
  kjuup_io_company_seat_active: 'Your company seat is active.',
  kjuup_io_open_admin_panel: 'Open Admin Panel',
  kjuup_io_open_admin_panel_short: 'Admin Panel',
  kjuup_io_company_trial_ended_title: 'Free trial ended!',
  kjuup_io_company_trial_ended_body:
    'The Kjuup.io subscription can be assigned via the Admin Center.',
  kjuup_io_company_trial_ended_contact_admins:
    'The Kjuup.io subscription can be assigned by {admins} via the Admin Center.',
  kjuup_io_todo_calendar_trial_ended_admin: 'Calendar sync · contact your admin',

  kjuup_io_your_company: 'your company',
  kjuup_io_choose_plan: 'Choose your plan',
  kjuup_io_plan_monthly: 'Monthly',
  kjuup_io_plan_yearly: 'Yearly',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Secured by Stripe · cancel anytime',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Payment received. Activating your subscription…',
  kjuup_io_toast_activating_soon: 'Payment received. Your subscription will activate shortly.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',
  kjuup_io_activate_to_sync_calendar: "Activate Kjuup.io to sync ToDos with my calendar",
  kjuup_io_todo_calendar_chip: "Calendar Sync · Activate Kjuup.io",
  kjuup_io_todo_calendar_nudge: "Sync this ToDo to your calendar?",
  kjuup_io_todo_calendar_nudge_cta: "Activate Kjuup.io",
  kjuup_io_todo_calendar_trial_ended_note: "Calendar sync · Subscribe",
  kjuup_io_todo_connect_calendar_banner: "Connect calendar",
  kjuup_io_todo_connect_calendar_cta: "Settings",

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} hours remaining',
  kjuup_io_trial_left_hour: '1 hour remaining',
  kjuup_io_trial_left_minutes: '{count} minutes remaining',
  kjuup_io_trial_left_minute: '1 minute remaining',
  kjuup_io_trial_left_seconds: '{count} seconds remaining',
  kjuup_io_trial_left_second: '1 second remaining',
  kjuup_io_trial_ending_now: 'Your trial is ending…',
  kjuup_io_request_timeout: 'The connection timed out. Please try again.',
  kjuup_io_info_days_free: '{days} days completely free – your subscription only starts after the trial.',
  kjuup_io_discount_total: 'Your discount: {percent}% off',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Personal: {percent}%',
  kjuup_io_trial_days_short: '{days} days left',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_trial_ends_today_short: 'Ends today',
  kjuup_io_trial_card_title: 'Your Kjuup.io trial ends in {days} days',
  kjuup_io_trial_card_title_today: 'Your Kjuup.io trial ends today',
  kjuup_io_trial_card_subtitle: 'Upgrade now to keep using all features.',
  kjuup_io_trial_card_progress: '{days} of {total} trial days remaining',
  kjuup_io_trial_card_cta: 'Upgrade now',
  kjuup_io_trial_card_days_unit: 'DAYS',
  kjuup_io_trial_card_day_unit: 'DAY',
  kjuup_io_banner_dismiss: 'Dismiss',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Your free trial has ended',
  kjuup_io_trial_ended_body: 'Subscribe to Kjuup.io to keep using email and other premium features.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Your free trial has started',
  kjuup_io_toast_trial_fail: 'Unable to start free trial',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / month',
  kjuup_io_billed_annually_amount: '{price} billed annually',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_save_amount_year: 'Save {price} per year',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'What you get:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'No credit card required – start immediately without entering payment details.',
  kjuup_io_info_cancel_anytime: 'Cancel anytime – no commitment, no risk.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Billing period',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Payment method saved. You\'ll be charged when the trial ends.',
  article_new_badge: 'NEW',
  article_new_posts: '{0} new posts',
  documents: 'Documents',
  add_documents: 'Add documents',
  no_preview_available: 'No preview available',
  no_preview_hint: 'This file type can\'t be previewed, but it will still be sent.',
  max_documents_reached: 'You can attach up to 10 documents at a time.',
  open_file: 'Download file',
  spreadsheet_preview_truncated: 'Showing the first 250 rows',
  twofa_title: 'Two-factor authentication',
  twofa_method_totp: 'Authenticator app',
  twofa_method_sms: 'Text message',
  twofa_method_email: 'Email',
  twofa_enter_app: 'Enter the 6-digit code from your authenticator app.',
  twofa_enter_sms: 'Enter the 6-digit code we sent by text message.',
  twofa_enter_email: 'Enter the 6-digit code we sent to your email.',
  twofa_resend: 'Resend code',
  twofa_try_another: 'Try another method',
  twofa_remember_device: 'Don\'t ask again on this device for 30 days',
  twofa_sent: 'We sent a code.',
  twofa_invalid_code: 'That code is incorrect. Please try again.',
  twofa_something_wrong: 'Something went wrong. Please try again.',
  twofa_method_unavailable: 'That verification method is not available.',
  twofa_on_desc: 'Two-factor authentication is on. You will need a code each time you sign in.',
  twofa_off_desc: 'Add a second step after your password. Authenticator apps are the most secure option.',
  twofa_methods: 'Methods',
  twofa_on: 'On',
  twofa_add: 'Add',
  twofa_default_method: 'Default method',
  twofa_default: 'Default',
  twofa_turn_off: 'Turn off',
  twofa_disable_hint: 'Enter your password and a current code to turn two-factor authentication off.',
  twofa_disable_need: 'Enter your password and a verification code.',
  twofa_code_placeholder: '6-digit code or backup code',
  twofa_send_code: 'Send a code',
  twofa_primary_updated: 'Default verification method updated.',
  twofa_disabled: 'Two-factor authentication is now off.',
  twofa_enabled: 'Two-factor authentication is now on.',
  twofa_totp_help: 'Scan this QR code with Google Authenticator, Authy, or 1Password. You can also enter the key manually.',
  twofa_secret_copied: 'Secret key copied',
  twofa_sms_help: 'Enter your mobile number in international format. We will text a 6-digit code.',
  twofa_email_help: 'We will email a 6-digit code to the address on your account.',
  twofa_backup_title: 'Backup codes',
  twofa_backup_help: 'Save these one-time codes in a safe place. Each code can be used once if you lose your phone.',
  twofa_copy_codes: 'Copy codes',
  twofa_codes_copied: 'Backup codes copied',
  twofa_regenerate: 'Get new backup codes',
  twofa_regenerate_hint: 'This replaces unused backup codes. Enter your password and a current code.',
  twofa_backup_remaining: '{n} unused backup codes remaining',
  twofa_new_codes: 'New backup codes',
  twofa_sms_unavailable: 'Text message codes are not available yet.',

  // ─── Cockpit (personal start page) ───────────────────────────────────────
  next: "Next",
  nav_news: "News",
  nav_email: "Email",
  nav_addons: "Optional",
  nav_soon: "soon",
  nav_off: "off",
  addon_click_to_enable: "disabled, click to enable",
  addon_enable: "Enable",
  addon_enable_confirm: "Enable add-on?",
  addon_enabled: "Add-on enabled",
  addon_chats_enable_confirm: "Enable Kjuup-Chats? Chats will be shown again in Messages and in the projects.",
  addon_chats_enabled: "Kjuup-Chats enabled",
  nav_recommend: "Recommend",
  startup_screen_cockpit: "Cockpit",
  recommend_text: "Join Kjuup to stay connected and keep your communication organized. Bring your channels together, keep messages in the right projects, and start each morning with a summary and your tasks—all synced with the apps you already use. Get started for free:",
  recommend_copied: "Referral link copied",
  recommend_subject: "Recommendation: Kjuup",
  products_kjuup_plus_sub: "for companies",
  products_kjuup_io_sub: "try or book",
  products_kjuup_io_sub_trial: "free trial",
  products_kjuup_plus_sub_active: "Active via company",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Subscription",
  kjuup_plus_abo_title: "Kjuup+ package",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (up to {max} employees)",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (up to {max} employees)",
  kjuup_plus_abo_status_active: "Active",
  kjuup_plus_abo_status_ends: "Ends on {date}",
  kjuup_plus_abo_status_requested: "Cancellation requested",
  kjuup_plus_abo_status_past_due: "Payment due",
  kjuup_plus_abo_seats_used: "{used} of {total} seats used",
  kjuup_plus_abo_seats_free: "{count} seats left",
  kjuup_plus_abo_seats_free_one: "1 seat left",
  kjuup_plus_abo_seats_next: "If more employees join, the package switches to {next} automatically (prorated).",
  kjuup_plus_abo_seats_over: "More than {max} employees – Kjuup will contact you with a custom offer.",
  kjuup_plus_abo_billing: "Billing",
  kjuup_plus_abo_monthly: "Monthly",
  kjuup_plus_abo_yearly: "Yearly",
  kjuup_plus_abo_amount: "Amount",
  kjuup_plus_abo_per_month: "/ month",
  kjuup_plus_abo_per_year: "/ year",
  kjuup_plus_abo_renews: "Next renewal",
  kjuup_plus_abo_ends: "Ends on",
  kjuup_plus_abo_next_invoice: "Next invoice",
  kjuup_plus_abo_intro: "Intro price",
  kjuup_plus_abo_intro_until: "until {date}",
  kjuup_plus_abo_pending_tier: "From next renewal",
  kjuup_plus_abo_manual: "Kjuup+ is active for your company under an individual agreement.",
  kjuup_plus_abo_invoices: "Invoices",
  kjuup_plus_abo_invoice_paid: "Paid",
  kjuup_plus_abo_invoice_open: "Open · due {date}",
  kjuup_plus_abo_invoice_view: "View",
  kjuup_plus_abo_invoices_all: "Show all {count}",
  kjuup_plus_abo_invoices_less: "Show less",
  kjuup_plus_abo_member_hint: "Billing and cancellation are managed by your company admins.",
  kjuup_plus_abo_cancel: "Cancel subscription",
  kjuup_plus_abo_cancel_hint: "Kjuup reviews your request and confirms the cancellation at the end of the term ({end}). Kjuup+ stays active until then.",
  kjuup_plus_abo_cancel_note: "Reason (optional)",
  kjuup_plus_abo_cancel_send: "Request cancellation",
  kjuup_plus_abo_requested: "Cancellation requested",
  kjuup_plus_abo_requested_hint: "Cancellation requested on {date}. Kjuup confirms it at the end of the term ({end}).",
  kjuup_plus_abo_withdraw: "Withdraw request",
  kjuup_plus_abo_withdrawn: "Cancellation request withdrawn",
  products_sub_active: "Subscription active",
  products_sub_trialing: "Trial active",
  kjuup_io_seat_company_admin_only: "The Kjuup.io package for your account can only be booked by your company admin. Contact your company admin for your Kjuup.io seat.",
  kjuup_io_seat_company_admins: "The Kjuup.io package for your account can only be booked by your company admins {{admins}}. Contact {{admins}} for your Kjuup.io seat.",
  cockpit_plus_io_ask_admins: "The Kjuup.io package for your account can only be booked by your company admins.",
  cockpit_io_contact_admin: "Contact",
  cockpit_active_plan: "Active subscription",
  cockpit_io_plan: "Kjuup.io subscription",
  cockpit_io_settings: "Kjuup.io Settings",
  cockpit_io_settings_sub: "Plan and seats, employee assignment, billing and invoices.",
  products_josch_sub: "your personal office assistant",
  products_projektview_sub: "smart project controlling",
  products_kostenprognose_sub: "cost forecasts for construction projects",
  products_terminplan_sub: "scheduling for construction projects",
  products_coming_soon: "Coming soon",
  products_teaser_generic: "This product is in development and will appear here as soon as it is available. You will be able to use it directly from your Kjuup account.",
  products_josch_teaser: "Josch.IO becomes your personal office assistant: it takes calls, sorts requests, prepares answers and keeps your projects up to date.",
  products_projektview_teaser: "ProjektView brings clarity to complex construction projects: dates, costs and decisions at a glance – connected to your Kjuup projects.",
  products_kostenprognose_teaser: "Kostenprognose.IO turns tenders, change orders and market data into a reliable cost forecast for your project.",
  products_terminplan_teaser: "Terminplan.IO plans construction sequences, detects delays early and syncs dates with your Kjuup to-dos.",
  cockpit_title: "Cockpit",
  nav_my_cockpit: "My cockpit",
  cockpit_my_tasks: "My tasks",
  cockpit_my_tasks_today: "Due today",
  cockpit_my_tasks_sub: "Bookmarked tasks and tasks",
  cockpit_today_tasks_group: "Today's tasks",
  cockpit_today_tasks: "Today",
  cockpit_today_tasks_empty: "No tasks for today.",
  cockpit_greeting_morning: "Good morning",
  cockpit_greeting_day: "Good afternoon",
  cockpit_greeting_evening: "Good evening",
  cockpit_day_overview: "Your day at a glance",
  cockpit_assign_proposal: "{{name}} recognised – assign?",
  cockpit_assign_proposal_confirm: "Assign",
  cockpit_assign_proposal_dismiss: "Ignore",
  cockpit_todo_set_date: "Set date",
  cockpit_row_more_actions: "More actions",
  cockpit_my_tasks_title: "My tasks",
  cockpit_task_delete_failed: "The task could not be deleted.",
  cockpit_channels_title: "Channels",
  cockpit_channel_chat: "Kjuup chat",
  cockpit_channel_email: "Email",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_forward: "Forwarding address",
  cockpit_channel_not_set_up: "Not set up",
  cockpit_channel_set_up: "Set up",
  cockpit_channel_active: "Active",
  cockpit_channel_hidden: "Hidden",
  cockpit_channel_enable: "Enable",
  cockpit_channel_connected: "Connected",
  cockpit_channel_not_connected: "Not connected",
  cockpit_channel_connect: "Connect",
  cockpit_channel_check: "Check connection",
  cockpit_channel_fix: "Check",
  cockpit_channel_broken: "Connection lost",
  cockpit_channel_reconnect: "Reconnect",
  cockpit_channel_importing: "Importing",
  cockpit_channel_removing: "Disconnecting",
  cockpit_report_top5: "Top 5 priorities",
  cockpit_meta_rooms: "{{n}} active projects",
  cockpit_meta_participants: "{{n}} participants",
  cockpit_filter_project: "Project",
  cockpit_filter_all_projects: "All projects",
  cockpit_refresh: "Refresh",
  cockpit_tab_overview: "Overview",
  cockpit_tab_company: "Company",
  cockpit_load_error: "The cockpit could not be loaded.",
  cockpit_retry: "Try again",
  cockpit_yesterday: "Yesterday",
  cockpit_last: "last",
  cockpit_next: "next",
  cockpit_kpi_today: "Today",
  cockpit_kpi_today_desc: "Tasks and appointments",
  cockpit_kpi_today_hint: "Tasks dated today",
  cockpit_kpi_today_tasks: "Today's tasks",
  cockpit_kpi_today_tasks_desc: "ToDos dated today",
  cockpit_kpi_today_tasks_none: "No tasks dated today",
  cockpit_kpi_today_tasks_in_list: "In the task list",
  cockpit_kpi_news: "News",
  cockpit_kpi_news_desc: "New articles",
  cockpit_kpi_news_external: "{{n}} external",
  cockpit_kpi_news_internal: "{{n}} internal",
  cockpit_kpi_news_none: "No new articles",
  cockpit_kpi_bookmarks: "Bookmarked tasks",
  cockpit_kpi_tasks: "Tasks",
  cockpit_kpi_deadlines: "Deadlines",
  cockpit_kpi_appointments: "Appointments",
  cockpit_kpi_deadlines_tasks: "Deadlines & tasks",
  cockpit_group_tasks: "Deadlines & tasks",
  cockpit_group_appointments: "Appointments",
  cockpit_kpi_bookmarks_desc: "Create tasks",
  cockpit_kpi_bookmarks_none: "No bookmarked tasks",
  cockpit_kpi_next_at: "Next appointment at {{time}}",
  cockpit_kpi_overdue: "Overdue",
  cockpit_kpi_overdue_desc: "need your decision",
  cockpit_kpi_overdue_hint: "Deadline passed",
  cockpit_kpi_overdue_none: "Everything on schedule",
  cockpit_kpi_requested: "Requested",
  cockpit_kpi_requested_desc: "Follow up on answers and input",
  cockpit_kpi_requested_hint: "Requested by you, still open",
  cockpit_kpi_requested_none: "No open follow-ups",
  cockpit_kpi_messages: "New messages",
  cockpit_kpi_chats_n: "{{n}} chats",
  cockpit_kpi_emails_n: "{{n}} emails",
  cockpit_kpi_messages_project: "{{n}} of them project related",
  cockpit_priority_eyebrow: "Focus",
  cockpit_priority_title: "Important now",
  cockpit_priority_empty: "Nothing urgent",
  cockpit_priority_empty_hint: "Overdue, today's and requested tasks appear here.",
  cockpit_all_tasks: "All tasks",
  cockpit_chip_overdue: "Overdue",
  cockpit_chip_today: "Today",
  cockpit_calendar_week: "CW {{week}}",
  cockpit_prev_week: "Previous week",
  cockpit_next_week: "Next week",
  cockpit_chip_requested: "Requested",
  cockpit_todo_due: "Due {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "from {{name}}",
  cockpit_todo_since: "since {{when}}",
  cockpit_todo_no_date: "No date",
  cockpit_todo_no_project: "No project",
  cockpit_todo_change_project: "Change project",
  no_project_found: "No project found",
  cockpit_todo_general: "General",
  cockpit_todo_mark_done: "Mark as done",
  pro_todo_not_found: "This task is no longer available.",
  pro_todo_step_done: "Done",
  pro_todo_status: "Status",
  todo_calendar_add: "Add to calendar",
  todo_calendar_remove: "Remove from calendar",
  todo_calendar_added: "Added to your calendar",
  todo_calendar_added_later: "Added. Your calendar could not be reached; Kjuup will try again later.",
  todo_calendar_removed: "Removed from your calendar",
  todo_calendar_no_date: "Only a ToDo with a date can be added to a calendar.",
  todo_calendar_failed: "Your calendar could not be updated. Please try again.",
  todo_calendar_connect_title: "No calendar connected",
  todo_calendar_connect_body_web: "Connect a calendar in Calendar Sync settings to add ToDos to it.",
  todo_calendar_connect: "Connect",
  todo_calendar_date_title: "No date yet",
  todo_calendar_date_body_web: "This bookmarked task has no date yet. Set one to add it to your calendar.",
  todo_calendar_date_save: "Set date & add",
  cockpit_assign_none: "Nobody assigned",
  cockpit_today_eyebrow: "Today",
  cockpit_today_title: "My day",
  cockpit_tasks: "Tasks",
  cockpit_priority_date: "Date",
  cockpit_priority_save: "Save as task",
  cockpit_today_count: "{{n}} open",
  cockpit_today_empty: "No tasks for today",
  cockpit_today_empty_hint: "New tasks from chats, emails and daily reports appear here.",
  cockpit_upcoming_title: "Upcoming",
  cockpit_upcoming_sub: "Dated tasks within the next 7 days",
  cockpit_upcoming_n: "{{n}} in 7 days",
  cockpit_upcoming_empty: "No appointments in the next 7 days",
  cockpit_report_eyebrow: "Kjuup-Email",
  cockpit_report_title: "Daily reports",
  cockpit_report_all_projects: "All projects",
  cockpit_report_show_all: "Show all {{n}} daily reports",
  cockpit_report_show_less: "Show less",
  cockpit_report_show_previous: "Show previous daily reports",
  cockpit_report_hide_previous: "Hide previous daily reports",
  cockpit_report_delete: "Delete daily report",
  cockpit_report_delete_confirm: "Delete this daily report?",
  cockpit_report_deleted: "Daily report deleted",
  cockpit_report_unread: "New",
  cockpit_report_empty: "No daily report yet",
  cockpit_report_time_hint: "The daily report is created every day at {{hour}}:00 for the five most active projects.",
  cockpit_report_needs_mailbox: "Connect an email account so Kjuup can create a daily report with automatic tasks.",
  cockpit_report_create: "Create daily report",
  cockpit_report_clear_project: "Show all projects",
  cockpit_report_creating: "Creating the daily report …",
  cockpit_report_recreate: "Recreate daily report",
  cockpit_report_progress_queued: "Preparing the report",
  cockpit_report_progress_collecting: "Collecting e-mails, chats and tasks from your projects",
  cockpit_report_progress_reading: "Reusing content that was already analysed",
  cockpit_report_progress_summarizing: "Analysing content",
  cockpit_report_progress_emails: "Analysing e-mails",
  cockpit_report_progress_chats: "Analysing chat messages",
  cockpit_report_progress_documents: "Analysing attachments and documents",
  cockpit_report_progress_tasks: "Analysing tasks",
  cockpit_report_progress_priorities: "Putting together priorities, deadlines and decisions",
  cockpit_report_progress_count: "{{count}} items analysed",
  cockpit_report_progress_count_one: "1 item analysed",
  cockpit_report_progress_count_many: "{{count}} items analysed",
  cockpit_report_progress_hint: "This usually takes one to two minutes – you can keep using the cockpit meanwhile.",
  cockpit_report_creating_title: "Your daily report is being prepared",
  cockpit_report_created: "Daily report created",
  cockpit_report_create_failed: "The daily report could not be created.",
  cockpit_report_no_activity: "This project had no new messages or emails in the last 24 hours.",
  cockpit_report_room_unavailable: "This project is not available.",
  cockpit_report_room_empty: "No daily report for this project yet",
  cockpit_report_room_empty_hint: "Create a daily report for this project only.",
  cockpit_report_fazit: "Daily report",
  cockpit_report_active_rooms: "Active projects",
  cockpit_report_priorities: "Key tasks",
  cockpit_bookmarked_priorities: "Bookmarked tasks",
  cockpit_priorities_select: "Delete several",
  cockpit_priorities_selected: "{count} selected",
  cockpit_priorities_deleting: "Deleting …",
  cockpit_priorities_delete_confirm: "Are you sure you want to delete {count} bookmarked tasks?",
  cockpit_priorities_deleted: "{count} tasks deleted",
  cockpit_priorities_delete_failed: "{count} tasks could not be deleted",
  cockpit_report_appointments: "Appointments",
  cockpit_report_create_todo: "Create to-do",
  cockpit_report_source_missing: "The source message could not be found.",
  cockpit_report_todo_created: "To-do created",
  cockpit_report_todo_noted: "Task bookmarked",
  cockpit_report_none: "No entries.",
  cockpit_assistant_title: "Kjuup Assistant",
  cockpit_assistant_hint: "Tap and ask",
  cockpit_assistant_new: "{{n}} new",
  cockpit_assistant_important: "{{n}} important",
  cockpit_assistant_q_open: "What is open today?",
  cockpit_assistant_q_summarize: "Summarise the chat {{room}}",
  cockpit_assistant_q_overdue: "Which tasks are overdue?",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_connect: "Connect email",
  cockpit_email_none_title: "No email account connected yet",
  cockpit_email_none_client: "Connect Gmail, Outlook or IMAP to read, assign and answer emails directly in Kjuup.io.",
  cockpit_email_none_reports: "Connect your mailbox so Kjuup can assign incoming emails to your projects and create daily reports with tasks.",
  cockpit_email_reports_title: "Current email client",
  cockpit_email_reports_text: "No inbox in Kjuup.io · {{rooms}} projects with a daily report at {{hour}}:00 · incoming emails are assigned to your projects.",
  cockpit_email_incoming_title: "Emails",
  cockpit_email_incoming_sub: "Assign incoming and sent emails to your projects. You can adjust the assignment here.",
  cockpit_email_incoming_empty: "No incoming emails yet.",
  cockpit_email_sent_empty: "No sent emails yet.",
  cockpit_email_folder_inbox: "Inbox",
  cockpit_email_folder_sent: "Sent",
  cockpit_email_deleted: "Email deleted",
  cockpit_email_incoming_unassigned: "Not assigned",
  cockpit_email_incoming_unassigned_n: "{{n}} not assigned",
  cockpit_email_incoming_pick: "Choose project …",
  cockpit_email_incoming_adjust: "Adjust assignment",
  cockpit_email_incoming_remove: "Remove assignment",
  cockpit_email_incoming_suggested: "Suggested: {{room}}",
  cockpit_email_incoming_apply: "Apply",
  cockpit_email_incoming_saving: "Saving …",
  cockpit_email_incoming_show_all: "Show all {{n}}",
  cockpit_email_incoming_show_less: "Show less",
  cockpit_email_reports_rooms: "Manage projects",
  cockpit_email_settings: "Email settings",
  cockpit_email_client_title: "Inbox connected",
  cockpit_email_error_title: "Check connection",
  cockpit_email_accounts_n: "{{n}} account connected",
  cockpit_email_last_sync: "last sync {{when}}",
  cockpit_email_report_at: "Daily report at {{hour}}:00",
  cockpit_email_open_inbox: "Open inbox",
  cockpit_email_open: "Open email",
  cockpit_email_detail_loading: "Loading email …",
  cockpit_email_detail_empty: "This email has no text.",
  cockpit_email_detail_failed: "The email could not be loaded.",
  cockpit_email_accounts_label: "Connected email addresses",
  cockpit_messages_title: "Latest messages",
  cockpit_messages_sub_both: "Chats and emails from all projects",
  cockpit_messages_sub_chats: "Chats from all projects",
  cockpit_messages_sub_emails: "Emails from all projects",
  cockpit_messages_empty: "No new messages",
  cockpit_all_messages: "All messages",
  cockpit_n_unread: "{{n}} unread",
  cockpit_src_chat: "Chat",
  cockpit_src_email: "Email",
  cockpit_projects_title: "Projects",
  cockpit_projects_sub: "Projects with status and activity",
  cockpit_projects_action: "{{n}} need attention",
  cockpit_projects_empty: "No projects yet",
  cockpit_projects_empty_hint: "Create your most important project.",
  cockpit_col_project: "Project",
  cockpit_col_status: "Status",
  cockpit_col_participants: "Participants",
  cockpit_col_open_tasks: "Open tasks",
  cockpit_col_new_messages: "New messages",
  cockpit_col_last_activity: "Last activity",
  cockpit_status_action: "Needs attention",
  cockpit_status_open: "Tasks open",
  cockpit_status_ok: "On track",
  cockpit_room_internal: "Internal",
  cockpit_room_external: "External",
  cockpit_upsell_io_title: "Your office that thinks along",
  cockpit_upsell_io_text: "Connect your email accounts with Kjuup. Emails, attachments and messages are saved automatically in the matching project and can optionally be stored on your server. Every day you get a summary of all projects with the key points from all content, and your tasks sync with your calendar or to-do app.",
  cockpit_upsell_io_f1: "Email client with project assignment",
  cockpit_upsell_io_f2: "Daily report with automatic tasks",
  cockpit_upsell_io_f3: "Kjuup Assistant for summaries",
  cockpit_upsell_io_cta_trial: "Try Kjuup.io for free",
  cockpit_upsell_io_cta_book: "Book Kjuup.io",
  cockpit_upsell_io_cta_request: "Request information",
  cockpit_upsell_io_soon_title: "Not bookable yet",
  cockpit_upsell_io_soon_text: "Kjuup.io is launching soon. Request information now – we will let you know as soon as you can book Kjuup.io.",
  cockpit_upsell_io_planned_price: "Planned price",
  cockpit_upsell_io_note: "Booking in your personal settings.",
  cockpit_upsell_io_note_request: "We will get back to you.",
  cockpit_upsell_plus_title: "Kjuup+ for companies",
  cockpit_upsell_plus_text: "Manage employees, write permissions and company communication in one place. Internal channels stay with your team, external channels connect you with project partners, and you can reach specific groups directly. In addition to Kjuup+, you can book Kjuup.io access for employee groups. Kjuup+ and Kjuup.io can be combined.",
  cockpit_upsell_plus_f1: "Manage all your employees' communication activity",
  cockpit_upsell_plus_f2: "Inform specific user groups within the company",
  cockpit_upsell_plus_f3: "Save internal group chats",
  cockpit_upsell_plus_cta: "Enquire without obligation",
  cockpit_upsell_plus_note: "Opens the request form on kjuup.de. We will get back to you.",
  cockpit_upsell_plus_badge: "INTRO PRICE FOR {months} MONTHS",
  cockpit_upsell_plus_size: "Company size",
  cockpit_upsell_plus_size_small: "1–50 employees",
  cockpit_upsell_plus_size_large: "51–200 employees",
  cockpit_upsell_plus_billing: "Billing",
  cockpit_upsell_plus_per_company: "/ company · month excl. VAT",
  cockpit_upsell_plus_intro_hint: "first {months} months, then {price}",
  cockpit_upsell_plus_when_yearly: "when paying annually",
  cockpit_upsell_plus_onboarding: "Onboarding/introduction costs depend on company size",
  cockpit_upsell_plus_larger: "Pricing for larger companies on request",
  cockpit_plus_io_title: "Kjuup.io for your team",
  cockpit_plus_io_admin: "As a company admin you book Kjuup.io for yourself and your team in the personal settings.",
  cockpit_plus_io_member: "Kjuup.io is booked via your company. Please contact {{admins}}.",
  cockpit_plus_io_member_generic: "Kjuup.io is booked via your company. Please contact a company admin.",
  cockpit_plus_io_view: "View Kjuup.io",
  cockpit_plus_io_not_enabled: "Kjuup.io is not yet enabled for your company. Request activation and we will get back to you.",
  cockpit_setup_title: "Finish setup",
  cockpit_setup_text: "Decide whether you want to use chats and whether Kjuup.io should work as an email client or only with projects and daily reports.",
  cockpit_setup_cta: "Set up now",
  cockpit_company_eyebrow: "Company",
  cockpit_back: "Back to overview",
  cockpit_company_none: "No Kjuup+ company found",
  cockpit_company_profile: "Company profile",
  cockpit_companies: "Companies",
  cockpit_company_settings: "Company settings",
  cockpit_personal_settings: "Personal settings",
  cockpit_company_inactive: "inactive",
  cockpit_company_employees: "Employees",
  cockpit_company_internal_rooms: "Internal projects",
  oversight_tab_members: "Members",
  rooms_oversight: "Supervision",
  rooms_oversight_info: "In Supervision, company admins can see all Kjuup chat data of all employees and manage writing rights in the chats.",
  oversight_rooms_description: "Select a project to view the associated members as well as all collected media and chats of all employees.",
  archived_rooms: "Archived projects",
  oversight_no_rooms: "No projects found",
  oversight_no_rooms_match: "No projects match your search",
  oversight_rooms_load_error: "The projects could not be loaded.",
  oversight_archive_room: "Archive project",
  oversight_restore_room: "Restore project",
  oversight_archive_room_title: "Archive this project?",
  oversight_restore_room_title: "Restore this project?",
  oversight_archive_room_desc: "The project \"{room}\" will be archived and hidden from the app. This function is only available for internal projects.",
  oversight_restore_room_desc: "The project \"{room}\" will be restored and visible in the app again. This function is only available for internal projects.",
  oversight_archive_action: "Archive",
  oversight_restore_action: "Restore",
  oversight_archive_room_success: "Project archived successfully",
  oversight_restore_room_success: "Project restored successfully",
  oversight_archive_room_error: "Failed to archive project",
  oversight_restore_room_error: "Failed to restore project",
  cockpit_room_admin: "Project & Chat Management",
  cockpit_room_admin_sub: "All company projects with members, media and chats.",
  cockpit_company_admins: "Contacts",
  cockpit_company_admins_sub: "Company admins of your company",
  cockpit_company_admins_none: "No admins listed",
  cockpit_company_rooms_sub: "{{n}} projects in your company",
  cockpit_company_rooms_none: "No internal projects yet",
  cockpit_company_rooms_show_all: "Show all {{n}} internal projects",
  cockpit_company_rooms_show_less: "Show less",
  cockpit_company_news: "Internal news",
  cockpit_company_admin_title: "Admin center",
  cockpit_company_admin_sub: "Manage this company here in Kjuup",
  cockpit_company_role_super_admin: "Company admin",
  cockpit_company_role_admin: "Department admin",
  cockpit_company_role_dept_admin: "Department admin",
  cockpit_company_role_member: "Employee",
  kjuup_io_setup_step: "Step",
  kjuup_io_setup_chats_title: "Do you want to use chats?",
  kjuup_io_setup_chats_sub: "Chats with colleagues and project partners are optional. You can show or hide them on the cockpit at any time.",
  kjuup_io_setup_chats_yes: "Yes, show chats",
  kjuup_io_setup_chats_yes_text: "Messages contains chats and emails. Projects have group chats for everyone involved.",
  kjuup_io_setup_chats_no: "No, work without chats",
  kjuup_io_setup_chats_no_text: "Chats are hidden. \"Messages\" becomes \"Email\"; projects, tasks and daily reports stay.",
  kjuup_io_setup_email_title: "Where do you want to read your emails?",
  kjuup_io_setup_email_sub: "This only chooses whether you use an email client in Kjuup or keep using your current email program, such as Outlook or another. You can switch later.",
  kjuup_io_setup_email_client: "Email client in Kjuup",
  kjuup_io_setup_email_client_text: "Read and reply to emails directly in Kjuup.",
  kjuup_io_setup_email_reports: "Current email client",
  kjuup_io_setup_email_reports_text: "Keep reading and replying in your current program, such as Outlook or another.",
  kjuup_io_setup_skip: "Later",
  kjuup_io_setup_finish: "Finish setup",
  kjuup_io_setup_saved: "Setup saved",
  cockpit_toggle_chats: "Kjuup-Chats",
  cockpit_workspace: "Workspace",
  cockpit_toggle_chats_off: "Chats are hidden in Messages and in projects. Messages becomes Email. Projects, tasks and daily reports stay.",
  cockpit_toggle_chats_info: "Show or hide Kjuup chats everywhere. When hidden, the members of your existing chats are told that you can no longer be reached via Kjuup chat.",
  chats_hidden_member_notice: "{name} has hidden chats and can no longer be reached via chat in Kjuup.",
  chats_hidden_label: "Chats hidden",
  cockpit_toggle_email: "Email client",
  cockpit_toggle_email_off: "The email client in Kjuup is hidden. You keep reading and replying in your current program, such as Outlook. Daily reports stay on the cockpit.",
  cockpit_toggle_email_info: "Read and reply to emails inside Kjuup.",
  cockpit_toggle_teams: "Microsoft Teams",
  cockpit_toggle_teams_info: "Read and reply to Teams chats inside Kjuup.",
  workspace_chats_label: "Show chats",
  workspace_chats_info: "When disabled, chats are hidden in Kjuup.io. \"Messages\" becomes \"Email\"; projects, tasks and daily reports remain.",
  workspace_email_mode_label: "Email mode",
  workspace_email_mode_client: "Email client in Kjuup",
  workspace_email_mode_reports: "Current email client",
  workspace_email_mode_intro: "This only chooses whether you use an email client in Kjuup or keep using your current email program, such as Outlook or another:",
  workspace_email_mode_client_info: "Read and reply to emails directly in Kjuup.",
  workspace_email_mode_reports_info: "Keep reading and replying in your current program, such as Outlook or another.",
  // --- Mobile parity: tasks ---
  pro_todo_title: "ToDo",
  pro_todo_new_task: "New task",
  pro_todo_filter: "Filter",
  pro_todo_section_upcoming: "Upcoming",
  pro_todo_section_done: "Done",
  pro_todo_today: "Today",
  pro_todo_tomorrow: "Tomorrow",
  pro_todo_yesterday: "Yesterday",
  pro_todo_since_yesterday: "Since yesterday",
  pro_todo_prev_week: "Previous week",
  pro_todo_next_week: "Next week",
  pro_todo_pick_date: "Pick a date",
  pro_todo_pick_date_chip: "Pick date",
  pro_todo_show_day: "Show day",
  pro_todo_showing: "Showing {{day}}",
  pro_todo_of_completed: "{{done}} of {{total}} completed",
  pro_todo_selected: "{{n}} selected",
  pro_todo_adjust_done: "Done",
  pro_todo_bulk_delete_title: "Delete {{n}} ToDos?",
  pro_todo_delete_title: "Delete task",
  pro_todo_deleting: "Deleting...",
  pro_todo_empty_title: "Nothing here",
  pro_todo_empty_hint: "No tasks match this view.",
  pro_todo_room_empty: "No tasks in this project",
  pro_todo_done_confirm: "Do you really want to mark this task as done?",
  pro_todo_mark_open: "Mark as open",
  pro_todo_task: "Task",
  pro_todo_more: "More",
  pro_todo_due: "Due",
  pro_todo_due_at: "Due {{when}}",
  pro_todo_created_by: "Created by",
  pro_todo_chat: "Chat",
  pro_todo_description: "Description",
  pro_todo_assignees: "Assignees",
  pro_todo_add_people: "Add people",
  pro_todo_search_people: "Search people",
  pro_todo_assigned: "(assigned)",
  pro_todo_status_open: "Open",
  pro_todo_status_done: "Done",
  pro_todo_bookmarked_tag: "Bookmarked task",
  pro_todo_activity: "Activity",
  pro_todo_show_all: "Show all ({{n}})",
  pro_todo_show_less: "Show less",
  pro_todo_reopen: "Reopen task",
  pro_todo_mark_in_progress: "Mark as in progress",
  pro_todo_mark_not_started: "Mark as not started",
  pro_todo_open_room: "Open project",
  pro_todo_go_to_message: "Go to message",
  pro_todo_go_to_email: "Go to e-mail",
  pro_todo_edit_title: "Edit task",
  pro_todo_room: "Project",
  pro_todo_what: "What needs to be done?",
  pro_todo_select_room: "Select project",
  pro_todo_no_room: "No project",
  pro_todo_assign_to: "Assign to",
  pro_todo_select_people: "Select people",
  pro_todo_create_task: "Create task",
  pro_todo_created: "Task created",
  pro_todo_enter_note: "Please enter a note",
  pro_todo_search_rooms: "Search projects",
  pro_todo_no_rooms: "No projects found",
  pro_todo_no_rooms_match: "No projects match “{{q}}”",
  pro_todo_no_people: "No people found",
  pro_todo_no_people_match: "No people match “{{q}}”",
  pro_todo_apply: "Apply",
  pro_todo_clear: "Clear",
  pro_todo_filter_clear_n: "Clear ({{n}})",
  pro_todo_filter_done: "{{p}}% done",
  pro_todo_one_task: "1 task",
  pro_todo_n_tasks: "{{n}} tasks",
  todo_apply_filters: "Apply",
  todo_confirmed: "ToDo confirmed",
  select_user_back_to_in_progress: "Select user to move back to In Progress",
  unassign_task_confirm: "Do you want to unassign yourself from this task?",
  v2_todo_remove: "Remove",
  // --- Mobile parity: chat ---
  chat_search_running: "Searching…",
  chat_search_press_enter: "Press Enter ↵ to search",
  chat_search_loading_hit: "Loading result {n}…",
  chat_search_no_results: "No results",
  chat_search_loading_to_hit: "Loading messages up to the result…",
  chat_copied_many: "{n} messages copied",
  chat_copied_one: "Message copied",
  chat_delete_messages_confirm: "Do you really want to delete these messages?",
  chat_image_copied: "Image copied",
  chat_info_delivered: "Delivered",
  chat_info_pending: "Not delivered yet.",
  chat_info_read: "Read",
  chat_menu_bookmark: "Bookmark",
  chat_menu_bookmark_remove: "Remove bookmark",
  chat_menu_edit: "Edit",
  chat_menu_save: "Save",
  chat_menu_select: "Select",
  chat_mic_unavailable: "No microphone found.",
  chat_save_failed: "The file could not be saved.",
  chat_select_to_forward: "Select the messages you want to forward.",
  chat_attach: "Attach",
  chat_edit_message: "Edit message",
  chat_emoji: "Insert emoji",
  chat_format_bold: "Bold",
  chat_format_bullets: "Bullet list",
  chat_format_italic: "Italic",
  chat_format_numbers: "Numbered list",
  chat_format_underline: "Underline",
  chat_is_typing: "is typing",
  chat_loading_newer: "Loading newer messages…",
  chat_loading_older: "Loading older messages…",
  chat_members: "members",
  chat_message_placeholder: "Message",
  chat_more_reactions: "More reactions",
  chat_online: "online",
  chat_open_info: "Open chat info",
  chat_original: "Original",
  chat_photo: "Photo",
  chat_poll: "Poll",
  chat_reactions_who: "Right-click: who reacted",
  chat_record_voice: "Record voice message",
  chat_recording_delete: "Delete recording",
  chat_reply_to: "Reply to",
  chat_retry_send: "Send again",
  chat_save_edit: "Save",
  chat_scroll_latest: "Scroll to latest",
  chat_search_clear: "Clear",
  chat_search_close: "Close search",
  chat_search_in_chat: "Search in chat",
  chat_search_next: "Next match",
  chat_search_placeholder: "Search in this chat",
  chat_search_prev: "Previous match",
  chat_select_message: "Select message",
  chat_selected: "selected",
  chat_send: "Send",
  chat_send_voice: "Send voice message",
  chat_show_original: "Show original",
  chat_show_translation: "Show translation",
  chat_status_pending: "Sending…",
  chat_status_sent: "Sent",
  chat_translated: "Translated",
  chat_translated_from: "Translated from",
  chat_translating: "Translating…",
  chat_typing: "typing",
  chat_unread_many: "unread messages",
  chat_unread_one: "unread message",
  chat_yourself: "yourself",
  chat_info_title_contact: "Contact info",
  chat_info_title_chat: "Chat info",
  chat_info_title_room: "Project chat info",
  chat_info_title_group: "Group info",
  chat_info_online: "Online",
  chat_info_mute: "Mute",
  chat_info_unmute: "Unmute",
  chat_info_media: "Files",
  chat_info_export: "Export",
  chat_info_members: "Members",
  chat_info_member_one: "1 member",
  chat_info_members_count: "{n} members",
  chat_info_kind_room: "Project",
  chat_info_kind_group: "Group",
  chat_info_external: "External",
  chat_info_send_message: "Send message",
  chat_info_description: "Description",
  chat_info_add: "Add",
  chat_info_no_members: "No members found",
  chat_info_leave_group: "Leave chat group",
  chat_info_leave_confirm: "Do you really want to leave the chat group?",
  chat_share_title: "Share",
  chat_share_gallery: "Gallery",
  chat_share_meeting_point: "Meeting point",
  chat_share_task: "Task",
  chat_location_search: "Search address",
  chat_location_accuracy_50: "Accurate to 50 m",
  chat_location_accuracy_10: "Accurate to 10 m",
  chat_location_send_meeting: "Send meeting point",
  chat_location_getting: "Getting your location …",
  chat_location_unavailable: "Location unavailable. Search for an address.",
  chat_location_tap_map: "Tap the map to set the meeting point.",
  chat_location_drag_hint: "Drag the pin to adjust the meeting point.",
  chat_location_my_location: "My location",
  chat_voice_play: "Play voice message",
  chat_voice_pause: "Pause",
  chat_voice_speed: "Speed",
  chat_voice_ai_transcript: "AI transcript",
  chat_voice_transcribing: "Transcription in progress…",
  chat_doc_download: "Download",
  chat_doc_retry: "Retry",
  chat_poll_you_voted: "You voted",
  chat_forward_to_one: "Forward to 1 chat",
  chat_forward_to_n: "Forward to {n} chats",
  chat_forward_select: "Select chats",
  // --- Mobile parity: chat list ---
  reply_sending_photo: "Sending photo…",
  reply_sending_photos: "Sending photos… {0}/{1}",
  reply_media_sent: "Sent",
  kjuup_messages_title: "Messages",
  pro_messages_unread: "Unread",
  pro_messages_rooms: "Projects",
  pro_messages_groups: "Groups",
  pro_messages_direct: "Direct",
  pro_messages_no_chats_filter: "No chats in this filter",
  pro_messages_row_more: "More options",
  pro_messages_remove_bookmark: "Remove bookmark",
  mark_as_task: "Mark as task",
  unmark_task: "Remove from tasks",
  pinned_room_pin: "Pin project",
  pinned_room_unpin_room: "Unpin project",
  pro_messages_typing: "typing…",
  v2_chat_is_typing: "is typing",
  pro_messages_tag_mail: "Mail",
  pro_messages_selected: "{n} selected",
  date_format_short: "MM/DD/YY",
  chat_list_audio_duration: "Duration",
  chat_muted: "Muted",
  // --- Mobile parity: personal settings ---
  pro_settings_on: "On",
  pro_settings_off: "Off",
  pro_settings_all: "All",
  pro_settings_profile: "Profile",
  pro_settings_security: "Security & 2-step login",
  pro_settings_unavailability: "Unavailability",
  pro_settings_company: "Company",
  pro_settings_my_companies: "My companies",
  pro_settings_admin_center: "Admin center",
  pro_settings_app: "App",
  pro_settings_logout: "Log out",
  pro_settings_delete_profile: "Delete profile",
  pro_settings_search: "Search settings",
  pro_settings_search_empty: "No settings match “{{q}}”",
  pro_settings_no_results: "No results",
  pro_settings_plan_title: "{{pkg}} plan",
  pro_settings_plan_sub: "Compare plans and manage seats",
  pro_settings_plan_sub_static: "Your current package",
  pro_settings_made_in: "Made in Germany",
  pro_settings_unavail_period: "Period",
  pro_settings_email: "E-mail",
  pro_settings_phone: "Phone",
  pro_settings_choose: "Choose",
  pro_settings_save: "Save",
  pro_settings_push: "Push",
  pro_settings_quiet_hours: "Quiet hours",
  pro_settings_notification_hours: "Notification hours",
  pro_settings_quiet_from: "From",
  pro_settings_quiet_until: "Until",
  pro_settings_quiet_all_day: "Quiet all day",
  pro_settings_push_allowed_browser: "Push notifications are allowed in this browser",
  pro_settings_push_off_browser: "Push notifications are off in this browser",
  pro_settings_push_allow_browser: "Allow notifications",
  pro_settings_cal_connect: "Connect a calendar",
  pro_settings_cal_google: "Google Calendar",
  pro_settings_cal_outlook: "Outlook Calendar",
  pro_settings_cal_apple: "Apple / CalDAV",
  pro_settings_profile_role_required: "Please select your role in the building industry.",
  pro_settings_profile_first_name_required: "Please enter your first name.",
  pro_settings_profile_last_name_required: "Please enter your last name.",
  v2_settings_account: "Account",
  v2_settings_workspace: "Kjuup.io workspace",
  v2_settings_delete_title: "Delete profile?",
  v2_settings_connected: "Connected",
  v2_notif_weekdays: "Weekdays",
  v2_auth_twofa_off_confirm: "Turn off two-factor authentication?",
  v2_profile_edit_title: "Edit profile",
  v2_profile_edit_photo: "Edit photo",
  recommend_kjuup: "Recommend Kjuup",
  confirm_logout: "Confirm to log out",
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Tasks stay in sync both ways inside your Todoist project named Kjuup. A task you create there becomes a personal Kjuup task.",
  todoist_connect: "Connect Todoist",
  todoist_connected: "Todoist connected",
  todoist_connect_failed: "Todoist connection failed",
  todoist_disconnect: "Disconnect",
  todoist_disconnected: "Todoist disconnected",
  todoist_disconnect_confirm: "Disconnect Todoist? Tasks already in Todoist stay there. Sync stops.",
  todoist_sync_now: "Sync now",
  todoist_syncing: "Syncing…",
  todoist_sync_done: "Sync finished",
  todoist_sync_failed: "Sync failed",
  todoist_auth_error: "Reconnect Todoist to keep syncing.",
  todoist_last_sync: "Last sync",
  todoist_not_connected: "Todoist is not connected",
  todoist_auth_url_failed: "Could not open the Todoist authorization page.",
  // --- Mobile parity: plans ---
  pro_settings_plans: "Plans",
  pro_settings_plan_current: "Current",
  pro_settings_plan_switch: "Switch to {{pkg}}",
  pro_settings_plan_kjuup_tag: "Chat, projects and tasks",
  pro_settings_plan_kjuup_f1: "Projects and chats",
  pro_settings_plan_kjuup_f2_priorities: "ToDo and bookmarked tasks",
  pro_settings_plan_plus_tag: "For growing companies",
  pro_settings_plan_plus_f1: "Everything in Kjuup",
  pro_settings_plan_plus_f2: "Company articles and internal news",
  pro_settings_plan_plus_f3: "Company documents",
  pro_settings_plan_plus_f4: "Admin center",
  pro_settings_plan_plus_note: "Kjuup+ is booked by your company.",
  pro_settings_plan_io_tag_v2: "E-mail, daily report and automations",
  pro_settings_plan_io_admin_body: "You manage the Kjuup.io seats of {{company}}.",
  pro_settings_plan_manage_seats: "Manage seats",
  pro_settings_plan_per_month: "/ month",
  pro_settings_plan_per_year: "/ year",
  // --- Mobile parity: company settings ---
  pro_company_admin_caption_admins: "Administration",
  pro_company_admin_caption_company: "Company",
  v2_company_no_members: "Nobody yet",
  company_language_none: "No language found",
  company_settings_load_error: "The company settings could not be loaded.",
  company_settings_none: "There are no settings for this company here.",
  company_notification_start_time: "Start time",
  company_notification_end_time: "End time",
  admin_center_group_company: "Company",
  admin_center_group_people: "Add people",
  admin_center_group_settings: "Settings",
  admin_center_articles: "Articles",
  admin_center_media_export: "Media export server",
  admin_center_eyebrow_admin: "Company admin",
  admin_center_load_error: "The admin center could not be loaded.",
  admin_center_admins_only: "The admin center is only available to company admins.",
  // --- Mobile parity: news ---
  pro_news_post: "Post",
  pro_news_search_external: "Search news",
  pro_news_search_internal: "Search internal news",
  pro_news_search_in: "Search {0}",
  pro_news_search_count_one: "1 post",
  pro_news_search_count_many: "{0} posts",
  pro_news_clear_search: "Clear search",
  pro_news_feed_caption: "Articles",
  pro_news_external: "External",
  pro_news_internal: "Internal",
  pro_news_company_showing: "Showing articles of {name}",
  pro_news_company_pick: "Choose company",
  pro_news_company_search: "Search company",
  pro_news_company_none: "No company found",
  pro_news_company_new_one: "1 new post",
  pro_news_company_new_n: "{n} new posts",
  pro_news_company_other_one: "1 new post in another company",
  pro_news_company_other_n: "{n} new posts in other companies",
  pro_news_pinned: "Pinned",
  pro_news_pin: "Pin",
  pro_news_unpin: "Unpin",
  pro_news_more: "More",
  pro_news_show_likes: "Show likes ({0})",
  pro_news_time_now: "now",
  pro_news_time_minutes: "{0} min ago",
  pro_news_time_hours: "{0} h ago",
  pro_news_read_more: "Read more",
  pro_news_empty_title: "No article found",
  pro_news_empty_search_hint: "Try a different search term.",
  previous: "Previous",
  pro_auth_signin_title: 'Welcome back',
  pro_auth_signin_sub: 'Sign in with your work e-mail.',
  pro_auth_email_or_username: 'E-mail or username',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'Forgot password?',
  pro_auth_create_account: 'Create account',
  pro_auth_show_password: 'Show password',
  pro_auth_hide_password: 'Hide password',
  pro_auth_register_sub: 'We\'ll send you a link to confirm your e-mail.',
  pro_auth_register_plus_sub: 'Choose a username and a password. Next you set your security PIN.',
  pro_auth_check_credentials: 'Check your e-mail and password',
  pro_news_export_pdf: 'Export as PDF',
  pro_news_pdf_failed: 'The PDF could not be created.',
  pro_news_pdf_attachments: 'Attachments',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Enter your e-mail and we\'ll send you a link to reset your password.',
  pro_auth_send_link: 'Send reset link',
  pro_auth_plus_reset: 'Reset with PIN',
  pro_auth_show_pin: 'Show PIN',
  pro_auth_hide_pin: 'Hide PIN',
  v2_auth_plus_only: 'Kjuup+ only',
  // --- Microsoft Teams (mobile parity: Teams setup) ---
  teams_title: 'Microsoft Teams',
  teams_info: 'Read and answer your Microsoft Teams chats in Kjuup. They appear in Messages with a TEAMS tag.',
  teams_connect: 'Connect Microsoft Teams',
  teams_connecting: 'Connecting…',
  teams_reconnect: 'Reconnect Microsoft Teams',
  teams_connect_again: 'Connect again',
  teams_disconnect: 'Disconnect',
  teams_disconnecting: 'Disconnecting…',
  teams_sync_now: 'Sync now',
  teams_syncing: 'Syncing…',
  teams_sync_queued: 'Sync started',
  teams_sync_already: 'A sync is already running.',
  teams_chip_importing: 'Importing',
  teams_chip_not_connected: 'Not connected',
  teams_chip_reconnect: 'Reconnect',
  teams_chip_removing: 'Removing',
  teams_chip_archived: 'Read-only',
  teams_add_account: 'Add another Microsoft account',
  teams_chip_approved: 'Approved',
  teams_status_approved: 'Your IT approved Kjuup',
  teams_approved_body: 'Kjuup is now approved for your organisation. Connect your Microsoft account to finish.',
  teams_consent_granted_toast: 'Your IT approved Kjuup for Microsoft Teams. Connect your account in Settings → Microsoft Teams.',
  teams_account_caption: 'Microsoft account',
  teams_last_sync: 'Last sync',
  teams_not_available: 'Microsoft Teams is not available for your account yet.',
  teams_archive_note: 'Your imported Teams chats are kept as a read-only archive in Messages.',
  teams_status_removing: 'Removing your imported Teams chats…',
  teams_removing_body: 'You can connect Microsoft Teams again when this is finished.',
  teams_status_connecting: 'Setting up the connection…',
  teams_progress_hint: 'Recent chats come first, older messages follow. You can leave this page.',
  teams_progress_chats: '{{done}} of {{total}} chats',
  teams_progress_messages: '{{count}} messages imported',
  teams_status_importing: 'Importing your Teams chats…',
  teams_status_importing_history: 'Importing older messages…',
  teams_import_failed_web: 'Not all chats could be imported. Click Sync now to try again.',
  teams_status_consent: 'Approval by your IT admin needed',
  teams_consent_body: 'Your organization requires an IT admin to approve Kjuup for Microsoft Teams. Send them the approval link, then connect again.',
  teams_consent_copy: 'Copy link for IT admin',
  teams_consent_copied: 'Approval link copied. Send it to your IT admin.',
  teams_consent_open: 'Open approval page',
  teams_share_message: 'Please approve Kjuup for Microsoft Teams in our organization: {{url}}',
  teams_admin_link_failed: 'The approval link could not be created.',
  teams_status_policy: 'Blocked by your organization',
  teams_policy_body: "Your organization's policy does not allow connecting Kjuup to Microsoft Teams. Please contact your IT admin.",
  teams_status_reconnect: 'Reconnect needed',
  teams_reconnect_body: 'Kjuup can no longer reach your Teams chats. They stay read-only until you reconnect.',
  teams_connected_toast: 'Microsoft Teams connected. Your chats are being imported.',
  teams_disconnected: 'Microsoft Teams disconnected',
  teams_disconnect_title: 'Disconnect Microsoft Teams?',
  teams_disconnect_body: 'Kjuup stops syncing with Teams. Your chats in Microsoft Teams stay unchanged. What should happen to the imported chats in Kjuup?',
  teams_disconnect_delete: 'Delete imported chats',
  teams_disconnect_keep: 'Keep as read-only',
  teams_err_wrong_user: 'This sign-in was started by a different Kjuup user. Please connect again.',
  teams_err_expired: 'The sign-in has expired. Please connect again.',
  teams_err_not_entitled: 'Microsoft Teams is part of Kjuup.io. Activate Kjuup.io to connect.',
  teams_err_consent_required: 'Your IT admin must approve Kjuup for Microsoft Teams first.',
  teams_err_policy_blocked: "Your organization's policy does not allow connecting Kjuup to Microsoft Teams.",
  teams_err_personal_account: 'Personal Microsoft accounts are not supported. Sign in with your work or school account.',
  teams_err_cancelled: 'The Microsoft sign-in was cancelled.',
  teams_err_already_linked: 'This Microsoft account is already connected to another Kjuup user.',
  teams_err_different_account: 'A different Microsoft account is already connected. Disconnect it first.',
  teams_err_disconnect_in_progress: 'Your imported Teams chats are still being removed. Please try again in a few minutes.',
  teams_err_unavailable: 'Microsoft Teams is temporarily unavailable. Please try again later.',
  teams_err_too_soon: 'A sync was started a few minutes ago. Please try again later.',
  teams_err_generic: 'Microsoft Teams could not be connected. Please try again.',
  teams_err_disconnect: 'Microsoft Teams could not be disconnected. Please try again.',
  teams_delete_archive_body: 'Your imported Teams chats will be permanently removed from Kjuup. Your chats in Microsoft Teams stay unchanged.',
  pro_messages_tag_teams: 'Teams',
  teams_open_in_teams: 'Open in Teams',
  teams_read_only_reconnect: 'Reconnect Microsoft Teams in the settings to send messages.',
  teams_read_only_left: 'You are no longer a member of this Microsoft Teams chat.',
  teams_read_only: 'This Microsoft Teams chat is read-only.',
  teams_reconnect_action: 'Reconnect',
  teams_retry_failed: 'The message could not be sent again.',
  teams_file_unavailable: 'This file is only available in Microsoft Teams.',
  teams_call_audio_title: 'Teams call',
  teams_call_video_title: 'Teams video call',
  teams_call_meeting_title: 'Teams meeting',
  teams_call_join: 'Join now',
  teams_call_join_hint: 'Teams app or browser',
  teams_call_confirm_audio: 'Start a Teams call?',
  teams_call_confirm_video: 'Start a Teams video call?',
  teams_call_confirm_body: 'Kjuup sends a join link into this chat. Everyone in the chat can join in the Teams app or the browser.',
  teams_call_confirm_ok: 'Send link & join',
  teams_call_opening: 'Opening Teams…',
  teams_call_failed: 'The Teams call could not be started.',
  teams_call_consent_title: 'Allow Teams calls',
  teams_call_consent_body: 'For calls, Kjuup needs your one-time permission in Microsoft to create meetings.',
  teams_call_consent_ok: 'Allow',
  teams_call_consent_done: 'Teams calls are allowed.',
  teams_user_fallback: 'Teams user',
  teams_members: 'Members',
  teams_managed_in_teams: 'Members, name and leaving the chat are managed in Microsoft Teams.',
  teams_send_failed: 'Not sent to Teams',
  teams_sending: 'Sending to Teams…',
  teams_room_label: 'Project',
  teams_room_none: 'Not assigned',
  teams_room_assign: 'Assign project',
  teams_room_change: 'Change project',
  teams_room_remove: 'Remove assignment',
  teams_room_title: 'Assign Teams chat to a project',
  teams_room_hint: 'Messages from this Teams chat then appear in the daily report under the project, also in the project\'s own report. Project members do not see the chat.',
  teams_room_placeholder: 'Search projects',
  teams_room_save: 'Assign',
  teams_room_assigned: 'Teams chat assigned to the project.',
  teams_room_removed: 'Project assignment removed.',
  teams_room_not_assignable: 'This project is not available. It may be completed or you are no longer a member.',
  teams_room_no_rooms: 'You are not in any project yet.',
  teams_room_pick_existing: 'Please pick an existing project from the list.',
  teams_sender_you: 'You',
  pro_todo_project_required: "Please choose a project",
  pro_todo_choose_project: "Which project is this task for?",
  today_label: "today",
  tomorrow_label: "tomorrow",
  cockpit_todo_overdue: "overdue",
  cockpit_report_management_fazit: "Management summary",
  unknown: "–",
  cockpit_todo_appointment: "Appointment",
  cockpit_todo_deadline: "Deadline",
  cockpit_todo_deadline_define: "Define deadline",
  pro_todo_status_acknowledged: "Confirmed",
  pro_todo_responsible: "Responsible",
  pro_todo_notice_confirmed: "Confirmed in chat",
  pro_todo_notice_sent_at: "Message sent",
  pro_todo_notice_again: "Send the message again",
  pro_todo_notice_send: "Inform via Kjuup message",
  pro_todo_add_assignee: "Add",
  pro_todo_edit: "Edit",
  pro_todo_change_room: "Change project",
  pro_todo_due_on: "Due on",
  pro_todo_edit_due: "Edit due date",
  pro_todo_no_date: "No date",
  pro_todo_edit_description: "Edit description",
  pro_todo_no_description: "No description yet",
  pro_todo_title_label: "Title",
  pro_todo_title_placeholder: "Enter title...",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Sources",
  todo_created_from_message: "Task created from this message",
  cockpit_email_accounts_n_many: "{{n}} accounts connected",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup contacts",
  combined_tab_teams: "Teams contacts",
  combined_bridge_failed: "Teams copy could not be created.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup and Teams contacts: a new group is created that also appears in Microsoft Teams.",
  teams_new_chat_title: "New Teams chat",
  teams_new_chat_topic: "Group name (optional)",
  teams_new_chat_start: "Start chat",
  teams_new_chat_creating: "Creating chat…",
  teams_new_chat_forbidden: "Microsoft Teams does not allow this chat (e.g. a person outside your organisation or a policy of your IT).",
  teams_new_chat_too_many: "Too many people for one chat.",
  teams_new_chat_type_hint: "Type a name to search your organisation.",
  teams_new_chat_directory_forbidden: "Your organisation does not allow the directory search. Only people from your Teams chats are shown.",
  teams_new_chat_account: "Account",
};
